import { d as yt, i as Mt, j as St } from "./variables-dP5qqrAo.js";
import { g as kt, B as xt, H as ct } from "./chart-base-DQP-2wFc.js";
import { i as At, n as ft } from "./abstract-base-CdeHT0x1.js";
import { m as Ct } from "./lifecycle-decorators-VlFt_asj.js";
var vt = { exports: {} };
(function(dt) {
  /**
  * Highstock JS v11.4.8 (2024-08-29)
  *
  * Highcharts Stock as a plugin for Highcharts
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(st) {
    dt.exports ? (st.default = st, dt.exports = st) : st(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(st) {
    var x = st ? st._modules : {};
    function J(D, H, Y, V) {
      D.hasOwnProperty(H) || (D[H] = V.apply(null, Y), typeof CustomEvent == "function" && st.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: H, module: D[H] } })));
    }
    J(x, "Series/DataModifyComposition.js", [x["Core/Axis/Axis.js"], x["Core/Series/Point.js"], x["Core/Series/Series.js"], x["Core/Utilities.js"]], function(D, H, Y, V) {
      var Z;
      let { tooltipFormatter: q } = H.prototype, { addEvent: N, arrayMax: I, arrayMin: z, correctFloat: _, defined: C, isArray: M, isNumber: S, isString: U, pick: b } = V;
      return function(k) {
        function O(o, i, s) {
          !this.isXAxis && (this.series.forEach(function(l) {
            o === "compare" && typeof i != "boolean" ? l.setCompare(i, !1) : o !== "cumulative" || U(i) || l.setCumulative(i, !1);
          }), b(s, !0) && this.chart.redraw());
        }
        function c(o) {
          let i = this, { numberFormatter: s } = i.series.chart, l = function(t) {
            o = o.replace("{point." + t + "}", (i[t] > 0 && t === "change" ? "+" : "") + s(i[t], b(i.series.tooltipOptions.changeDecimals, 2)));
          };
          return C(i.change) && l("change"), C(i.cumulativeSum) && l("cumulativeSum"), q.apply(this, [o]);
        }
        function w() {
          let o, i = this.options.compare;
          (i === "percent" || i === "value" || this.options.cumulative) && (o = new r(this), i === "percent" || i === "value" ? o.initCompare(i) : o.initCumulative()), this.dataModify = o;
        }
        function g(o) {
          let i = o.dataExtremes, s = i.activeYData;
          if (this.dataModify && i) {
            let l;
            this.options.compare ? l = [this.dataModify.modifyValue(i.dataMin), this.dataModify.modifyValue(i.dataMax)] : this.options.cumulative && M(s) && s.length >= 2 && (l = r.getCumulativeExtremes(s)), l && (i.dataMin = z(l), i.dataMax = I(l));
          }
        }
        function y(o, i) {
          this.options.compare = this.userOptions.compare = o, this.update({}, b(i, !0)), this.dataModify && (o === "value" || o === "percent") ? this.dataModify.initCompare(o) : this.points.forEach((s) => {
            delete s.change;
          });
        }
        function B() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            let o = this.processedXData, i = this.processedYData, s = i.length, l = this.options.compareStart === !0 ? 0 : 1, t = -1, e;
            for (this.pointArrayMap && (t = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), e = 0; e < s - l; e++) {
              let a = i[e] && t > -1 ? i[e][t] : i[e];
              if (S(a) && a !== 0 && o[e + l] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = a;
                break;
              }
            }
          }
        }
        function d(o, i) {
          this.setModifier("compare", o, i);
        }
        function u(o, i) {
          o = b(o, !1), this.options.cumulative = this.userOptions.cumulative = o, this.update({}, b(i, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((s) => {
            delete s.cumulativeSum;
          });
        }
        function E(o, i) {
          this.setModifier("cumulative", o, i);
        }
        k.compose = function(o, i, s) {
          let l = i.prototype, t = s.prototype, e = o.prototype;
          return e.setCompare || (e.setCompare = y, e.setCumulative = u, N(o, "afterInit", w), N(o, "afterGetExtremes", g), N(o, "afterProcessData", B)), l.setCompare || (l.setCompare = d, l.setModifier = O, l.setCumulative = E, t.tooltipFormatter = c), o;
        };
        class r {
          constructor(i) {
            this.series = i;
          }
          modifyValue() {
            return 0;
          }
          static getCumulativeExtremes(i) {
            let s = 1 / 0, l = -1 / 0;
            return i.reduce((t, e) => {
              let a = t + e;
              return s = Math.min(s, a, t), l = Math.max(l, a, t), a;
            }), [s, l];
          }
          initCompare(i) {
            this.modifyValue = function(s, l) {
              s === null && (s = 0);
              let t = this.compareValue;
              if (s !== void 0 && t !== void 0) {
                if (i === "value" ? s -= t : s = s / t * 100 - (this.series.options.compareBase === 100 ? 0 : 100), l !== void 0) {
                  let e = this.series.points[l];
                  e && (e.change = s);
                }
                return s;
              }
              return 0;
            };
          }
          initCumulative() {
            this.modifyValue = function(i, s) {
              if (i === null && (i = 0), i !== void 0 && s !== void 0) {
                let l = s > 0 ? this.series.points[s - 1] : null;
                l && l.cumulativeSum && (i = _(l.cumulativeSum + i));
                let t = this.series.points[s], e = t.series.options.cumulativeStart, a = t.x <= this.series.xAxis.max && t.x >= this.series.xAxis.min;
                return t && (!e || a ? t.cumulativeSum = i : t.cumulativeSum = void 0), i;
              }
              return 0;
            };
          }
        }
        k.Additions = r;
      }(Z || (Z = {})), Z;
    }), J(x, "Stock/Navigator/ChartNavigatorComposition.js", [x["Core/Globals.js"], x["Core/Utilities.js"]], function(D, H) {
      let Y, { isTouchDevice: V } = D, { addEvent: Z, merge: q, pick: N } = H, I = [];
      function z() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function _() {
        var y;
        let k, O, c, w = this.legend, g = this.navigator;
        if (g) {
          k = w && w.options, O = g.xAxis, c = g.yAxis;
          let { scrollbarHeight: B, scrollButtonSize: d } = g;
          this.inverted ? (g.left = g.opposite ? this.chartWidth - B - g.height : this.spacing[3] + B, g.top = this.plotTop + d) : (g.left = N(O.left, this.plotLeft + d), g.top = g.navigatorOptions.top || this.chartHeight - g.height - B - (((y = this.scrollbar) == null ? void 0 : y.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (k && k.verticalAlign === "bottom" && k.layout !== "proximate" && k.enabled && !k.floating ? w.legendHeight + N(k.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), O && c && (this.inverted ? O.options.left = c.options.left = g.left : O.options.top = c.options.top = g.top, O.setAxisSize(), c.setAxisSize());
        }
      }
      function C(k) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new Y(this), N(k.redraw, !0) && this.redraw(k.animation));
      }
      function M() {
        let k = this.options;
        (k.navigator.enabled || k.scrollbar.enabled) && (this.scroller = this.navigator = new Y(this));
      }
      function S() {
        let k = this.options, O = k.navigator, c = k.rangeSelector;
        if ((O && O.enabled || c && c.enabled) && (!V && this.zooming.type === "x" || V && this.zooming.pinchType === "x")) return !1;
      }
      function U(k) {
        let O = k.navigator;
        if (O && k.xAxis[0]) {
          let c = k.xAxis[0].getExtremes();
          O.render(c.min, c.max);
        }
      }
      function b(k) {
        let O = k.options.navigator || {}, c = k.options.scrollbar || {};
        !this.navigator && !this.scroller && (O.enabled || c.enabled) && (q(!0, this.options.navigator, O), q(!0, this.options.scrollbar, c), delete k.options.navigator, delete k.options.scrollbar);
      }
      return { compose: function(k, O) {
        if (H.pushUnique(I, k)) {
          let c = k.prototype;
          Y = O, c.callbacks.push(U), Z(k, "afterAddSeries", z), Z(k, "afterSetChartSize", _), Z(k, "afterUpdate", C), Z(k, "beforeRender", M), Z(k, "beforeShowResetZoom", S), Z(k, "update", b);
        }
      } };
    }), J(x, "Core/Axis/NavigatorAxisComposition.js", [x["Core/Globals.js"], x["Core/Utilities.js"]], function(D, H) {
      let { isTouchDevice: Y } = D, { addEvent: V, correctFloat: Z, defined: q, isNumber: N, pick: I } = H;
      function z() {
        this.navigatorAxis || (this.navigatorAxis = new C(this));
      }
      function _(M) {
        let S, U = this.chart, b = U.options, k = b.navigator, O = this.navigatorAxis, c = U.zooming.pinchType, w = b.rangeSelector, g = U.zooming.type;
        if (this.isXAxis && (k != null && k.enabled || w != null && w.enabled)) {
          if (g === "y" && M.trigger === "zoom") S = !1;
          else if ((M.trigger === "zoom" && g === "xy" || Y && c === "xy") && this.options.range) {
            let y = O.previousZoom;
            q(M.min) ? O.previousZoom = [this.min, this.max] : y && (M.min = y[0], M.max = y[1], O.previousZoom = void 0);
          }
        }
        S !== void 0 && M.preventDefault();
      }
      class C {
        static compose(S) {
          S.keepProps.includes("navigatorAxis") || (S.keepProps.push("navigatorAxis"), V(S, "init", z), V(S, "setExtremes", _));
        }
        constructor(S) {
          this.axis = S;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(S, U, b, k) {
          let O = this.axis, c = (O.pointRange || 0) / 2, w = I(b, O.translate(S, !0, !O.horiz)), g = I(k, O.translate(U, !0, !O.horiz));
          return q(b) || (w = Z(w + c)), q(k) || (g = Z(g - c)), N(w) && N(g) || (w = g = void 0), { min: w, max: g };
        }
      }
      return C;
    }), J(x, "Stock/Navigator/NavigatorDefaults.js", [x["Core/Color/Color.js"], x["Core/Series/SeriesRegistry.js"]], function(D, H) {
      let { parse: Y } = D, { seriesTypes: V } = H;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: Y("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: V.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), J(x, "Stock/Navigator/NavigatorSymbols.js", [x["Core/Renderer/SVG/Symbols.js"], x["Core/Utilities.js"]], function(D, H) {
      let { relativeLength: Y } = H;
      return { "navigator-handle": function(V, Z, q, N, I = {}) {
        let z = I.width ? I.width / 2 : q, _ = Y(I.borderRadius || 0, Math.min(2 * z, N));
        return [["M", -1.5, (N = I.height || N) / 2 - 3.5], ["L", -1.5, N / 2 + 4.5], ["M", 0.5, N / 2 - 3.5], ["L", 0.5, N / 2 + 4.5], ...D.rect(-z - 1, 0.5, 2 * z + 1, N, { r: _ })];
      } };
    }), J(x, "Stock/Utilities/StockUtilities.js", [x["Core/Utilities.js"]], function(D) {
      let { defined: H } = D;
      return { setFixedRange: function(Y) {
        let V = this.xAxis[0];
        H(V.dataMax) && H(V.dataMin) && Y ? this.fixedRange = Math.min(Y, V.dataMax - V.dataMin) : this.fixedRange = Y;
      } };
    }), J(x, "Stock/Navigator/NavigatorComposition.js", [x["Core/Defaults.js"], x["Core/Globals.js"], x["Core/Axis/NavigatorAxisComposition.js"], x["Stock/Navigator/NavigatorDefaults.js"], x["Stock/Navigator/NavigatorSymbols.js"], x["Core/Renderer/RendererRegistry.js"], x["Stock/Utilities/StockUtilities.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z, q, N, I) {
      let { setOptions: z } = D, { composed: _ } = H, { getRendererType: C } = q, { setFixedRange: M } = N, { addEvent: S, extend: U, pushUnique: b } = I;
      function k() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(O, c, w) {
        Y.compose(c), b(_, "Navigator") && (O.prototype.setFixedRange = M, U(C().prototype.symbols, Z), S(w, "afterUpdate", k), z({ navigator: V }));
      } };
    }), J(x, "Core/Axis/ScrollbarAxis.js", [x["Core/Globals.js"], x["Core/Utilities.js"]], function(D, H) {
      var Y;
      let { composed: V } = D, { addEvent: Z, defined: q, pick: N, pushUnique: I } = H;
      return function(z) {
        let _;
        function C(b) {
          let k = N(b.options && b.options.min, b.min), O = N(b.options && b.options.max, b.max);
          return { axisMin: k, axisMax: O, scrollMin: q(b.dataMin) ? Math.min(k, b.min, b.dataMin, N(b.threshold, 1 / 0)) : k, scrollMax: q(b.dataMax) ? Math.max(O, b.max, b.dataMax, N(b.threshold, -1 / 0)) : O };
        }
        function M() {
          let b = this.scrollbar, k = b && !b.options.opposite, O = this.horiz ? 2 : k ? 3 : 1;
          b && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[O] += b.size + (b.options.margin || 0));
        }
        function S() {
          let b = this;
          b.options && b.options.scrollbar && b.options.scrollbar.enabled && (b.options.scrollbar.vertical = !b.horiz, b.options.startOnTick = b.options.endOnTick = !1, b.scrollbar = new _(b.chart.renderer, b.options.scrollbar, b.chart), Z(b.scrollbar, "changed", function(k) {
            let O, c, { axisMin: w, axisMax: g, scrollMin: y, scrollMax: B } = C(b), d = B - y;
            if (q(w) && q(g))
              if (b.horiz && !b.reversed || !b.horiz && b.reversed ? (O = y + d * this.to, c = y + d * this.from) : (O = y + d * (1 - this.from), c = y + d * (1 - this.to)), this.shouldUpdateExtremes(k.DOMType)) {
                let u = k.DOMType !== "mousemove" && k.DOMType !== "touchmove" && void 0;
                b.setExtremes(c, O, !0, u, k);
              } else this.setRange(this.from, this.to);
          }));
        }
        function U() {
          let b, k, O, { scrollMin: c, scrollMax: w } = C(this), g = this.scrollbar, y = this.axisTitleMargin + (this.titleOffset || 0), B = this.chart.scrollbarsOffsets, d = this.options.margin || 0;
          if (g && B) {
            if (this.horiz) this.opposite || (B[1] += y), g.position(this.left, this.top + this.height + 2 + B[1] - (this.opposite ? d : 0), this.width, this.height), this.opposite || (B[1] += d), b = 1;
            else {
              let u;
              this.opposite && (B[0] += y), u = g.options.opposite ? this.left + this.width + 2 + B[0] - (this.opposite ? 0 : d) : this.opposite ? 0 : d, g.position(u, this.top, this.width, this.height), this.opposite && (B[0] += d), b = 0;
            }
            if (B[b] += g.size + (g.options.margin || 0), isNaN(c) || isNaN(w) || !q(this.min) || !q(this.max) || this.dataMin === this.dataMax) g.setRange(0, 1);
            else if (this.min === this.max) {
              let u = this.pointRange / (this.dataMax + 1);
              k = u * this.min, O = u * (this.max + 1), g.setRange(k, O);
            } else k = (this.min - c) / (w - c), O = (this.max - c) / (w - c), this.horiz && !this.reversed || !this.horiz && this.reversed ? g.setRange(k, O) : g.setRange(1 - O, 1 - k);
          }
        }
        z.compose = function(b, k) {
          I(V, "Axis.Scrollbar") && (_ = k, Z(b, "afterGetOffset", M), Z(b, "afterInit", S), Z(b, "afterRender", U));
        };
      }(Y || (Y = {})), Y;
    }), J(x, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), J(x, "Stock/Scrollbar/Scrollbar.js", [x["Core/Defaults.js"], x["Core/Globals.js"], x["Core/Axis/ScrollbarAxis.js"], x["Stock/Scrollbar/ScrollbarDefaults.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z) {
      let { defaultOptions: q } = D, { addEvent: N, correctFloat: I, crisp: z, defined: _, destroyObjectProperties: C, fireEvent: M, merge: S, pick: U, removeEvent: b } = Z;
      class k {
        static compose(c) {
          Y.compose(c, k);
        }
        static swapXY(c, w) {
          return w && c.forEach((g) => {
            let y, B = g.length;
            for (let d = 0; d < B; d += 2) typeof (y = g[d + 1]) == "number" && (g[d + 1] = g[d + 2], g[d + 2] = y);
          }), c;
        }
        constructor(c, w, g) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(c, w, g);
        }
        addEvents() {
          let c = this.options.inverted ? [1, 0] : [0, 1], w = this.scrollbarButtons, g = this.scrollbarGroup.element, y = this.track.element, B = this.mouseDownHandler.bind(this), d = this.mouseMoveHandler.bind(this), u = this.mouseUpHandler.bind(this), E = [[w[c[0]].element, "click", this.buttonToMinClick.bind(this)], [w[c[1]].element, "click", this.buttonToMaxClick.bind(this)], [y, "click", this.trackClick.bind(this)], [g, "mousedown", B], [g.ownerDocument, "mousemove", d], [g.ownerDocument, "mouseup", u], [g, "touchstart", B], [g.ownerDocument, "touchmove", d], [g.ownerDocument, "touchend", u]];
          E.forEach(function(r) {
            N.apply(null, r);
          }), this._events = E;
        }
        buttonToMaxClick(c) {
          let w = (this.to - this.from) * U(this.options.step, 0.2);
          this.updatePosition(this.from + w, this.to + w), M(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: c });
        }
        buttonToMinClick(c) {
          let w = I(this.to - this.from) * U(this.options.step, 0.2);
          this.updatePosition(I(this.from - w), I(this.to - w)), M(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: c });
        }
        cursorToScrollbarPosition(c) {
          let w = this.options, g = w.minWidth > this.calculatedWidth ? w.minWidth : 0;
          return { chartX: (c.chartX - this.x - this.xOffset) / (this.barWidth - g), chartY: (c.chartY - this.y - this.yOffset) / (this.barWidth - g) };
        }
        destroy() {
          let c = this, w = c.chart.scroller;
          c.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(g) {
            c[g] && c[g].destroy && (c[g] = c[g].destroy());
          }), w && c === w.scrollbar && (w.scrollbar = null, C(w.scrollbarButtons));
        }
        drawScrollbarButton(c) {
          let w = this.renderer, g = this.scrollbarButtons, y = this.options, B = this.size, d = w.g().add(this.group);
          if (g.push(d), y.buttonsEnabled) {
            let u = w.rect().addClass("highcharts-scrollbar-button").add(d);
            this.chart.styledMode || u.attr({ stroke: y.buttonBorderColor, "stroke-width": y.buttonBorderWidth, fill: y.buttonBackgroundColor }), u.attr(u.crisp({ x: -0.5, y: -0.5, width: B, height: B, r: y.buttonBorderRadius }, u.strokeWidth()));
            let E = w.path(k.swapXY([["M", B / 2 + (c ? -1 : 1), B / 2 - 3], ["L", B / 2 + (c ? -1 : 1), B / 2 + 3], ["L", B / 2 + (c ? 2 : -2), B / 2]], y.vertical)).addClass("highcharts-scrollbar-arrow").add(g[c]);
            this.chart.styledMode || E.attr({ fill: y.buttonArrowColor });
          }
        }
        init(c, w, g) {
          this.scrollbarButtons = [], this.renderer = c, this.userOptions = w, this.options = S(V, q.scrollbar, w), this.options.margin = U(this.options.margin, 10), this.chart = g, this.size = U(this.options.size, this.options.height), w.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(c) {
          var y;
          let w = ((y = this.chart.pointer) == null ? void 0 : y.normalize(c)) || c, g = this.cursorToScrollbarPosition(w);
          this.chartX = g.chartX, this.chartY = g.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(c) {
          var d;
          let w, g = ((d = this.chart.pointer) == null ? void 0 : d.normalize(c)) || c, y = this.options.vertical ? "chartY" : "chartX", B = this.initPositions || [];
          this.grabbedCenter && (!c.touches || c.touches[0][y] !== 0) && (w = this.cursorToScrollbarPosition(g)[y] - this[y], this.hasDragged = !0, this.updatePosition(B[0] + w, B[1] + w), this.hasDragged && M(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: c.type, DOMEvent: c }));
        }
        mouseUpHandler(c) {
          this.hasDragged && M(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: c.type, DOMEvent: c }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(c, w, g, y) {
          let { buttonsEnabled: B, margin: d = 0, vertical: u } = this.options, E = this.rendered ? "animate" : "attr", r = y, o = 0;
          this.group.show(), this.x = c, this.y = w + this.trackBorderWidth, this.width = g, this.height = y, this.xOffset = r, this.yOffset = o, u ? (this.width = this.yOffset = g = o = this.size, this.xOffset = r = 0, this.yOffset = o = B ? this.size : 0, this.barWidth = y - (B ? 2 * g : 0), this.x = c += d) : (this.height = y = this.size, this.xOffset = r = B ? this.size : 0, this.barWidth = g - (B ? 2 * y : 0), this.y = this.y + d), this.group[E]({ translateX: c, translateY: this.y }), this.track[E]({ width: g, height: y }), this.scrollbarButtons[1][E]({ translateX: u ? 0 : g - r, translateY: u ? y - o : 0 });
        }
        removeEvents() {
          this._events.forEach(function(c) {
            b.apply(null, c);
          }), this._events.length = 0;
        }
        render() {
          let c = this.renderer, w = this.options, g = this.size, y = this.chart.styledMode, B = c.g("scrollbar").attr({ zIndex: w.zIndex }).hide().add();
          this.group = B, this.track = c.rect().addClass("highcharts-scrollbar-track").attr({ r: w.trackBorderRadius || 0, height: g, width: g }).add(B), y || this.track.attr({ fill: w.trackBackgroundColor, stroke: w.trackBorderColor, "stroke-width": w.trackBorderWidth });
          let d = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -z(0, d), y: -z(0, d) }), this.scrollbarGroup = c.g().add(B), this.scrollbar = c.rect().addClass("highcharts-scrollbar-thumb").attr({ height: g - d, width: g - d, r: w.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = c.path(k.swapXY([["M", -3, g / 4], ["L", -3, 2 * g / 3], ["M", 0, g / 4], ["L", 0, 2 * g / 3], ["M", 3, g / 4], ["L", 3, 2 * g / 3]], w.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), y || (this.scrollbar.attr({ fill: w.barBackgroundColor, stroke: w.barBorderColor, "stroke-width": w.barBorderWidth }), this.scrollbarRifles.attr({ stroke: w.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-z(0, this.scrollbarStrokeWidth), -z(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(c, w) {
          let g, y, B = this.options, d = B.vertical, u = B.minWidth, E = this.barWidth, r = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!_(E)) return;
          let o = E * Math.min(w, 1);
          g = Math.ceil(E * (c = Math.max(c, 0))), this.calculatedWidth = y = I(o - g), y < u && (g = (E - u + y) * c, y = u);
          let i = Math.floor(g + this.xOffset + this.yOffset), s = y / 2 - 0.5;
          this.from = c, this.to = w, d ? (this.scrollbarGroup[r]({ translateY: i }), this.scrollbar[r]({ height: y }), this.scrollbarRifles[r]({ translateY: s }), this.scrollbarTop = i, this.scrollbarLeft = 0) : (this.scrollbarGroup[r]({ translateX: i }), this.scrollbar[r]({ width: y }), this.scrollbarRifles[r]({ translateX: s }), this.scrollbarLeft = i, this.scrollbarTop = 0), y <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), B.showFull === !1 && (c <= 0 && w >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(c) {
          return U(this.options.liveRedraw, H.svg && !H.isTouchDevice && !this.chart.boosted) || c === "mouseup" || c === "touchend" || !_(c);
        }
        trackClick(c) {
          var d;
          let w = ((d = this.chart.pointer) == null ? void 0 : d.normalize(c)) || c, g = this.to - this.from, y = this.y + this.scrollbarTop, B = this.x + this.scrollbarLeft;
          this.options.vertical && w.chartY > y || !this.options.vertical && w.chartX > B ? this.updatePosition(this.from + g, this.to + g) : this.updatePosition(this.from - g, this.to - g), M(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: c });
        }
        update(c) {
          this.destroy(), this.init(this.chart.renderer, S(!0, this.options, c), this.chart);
        }
        updatePosition(c, w) {
          w > 1 && (c = I(1 - I(w - c)), w = 1), c < 0 && (w = I(w - c), c = 0), this.from = c, this.to = w;
        }
      }
      return k.defaultOptions = V, q.scrollbar = S(!0, k.defaultOptions, q.scrollbar), k;
    }), J(x, "Stock/Navigator/Navigator.js", [x["Core/Axis/Axis.js"], x["Stock/Navigator/ChartNavigatorComposition.js"], x["Core/Defaults.js"], x["Core/Globals.js"], x["Core/Axis/NavigatorAxisComposition.js"], x["Stock/Navigator/NavigatorComposition.js"], x["Stock/Scrollbar/Scrollbar.js"], x["Core/Renderer/SVG/SVGRenderer.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z, q, N, I, z) {
      let { defaultOptions: _ } = Y, { isTouchDevice: C } = V, { prototype: { symbols: M } } = I, { addEvent: S, clamp: U, correctFloat: b, defined: k, destroyObjectProperties: O, erase: c, extend: w, find: g, fireEvent: y, isArray: B, isNumber: d, merge: u, pick: E, removeEvent: r, splat: o } = z;
      function i(l, ...t) {
        let e = [].filter.call(t, d);
        if (e.length) return Math[l].apply(0, e);
      }
      class s {
        static compose(t, e, a) {
          H.compose(t, s), q.compose(t, e, a);
        }
        constructor(t) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(t);
        }
        drawHandle(t, e, a, n) {
          let h = this.navigatorOptions.handles.height;
          this.handles[e][n](a ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(t, 10) + 0.5 - h) } : { translateX: Math.round(this.left + parseInt(t, 10)), translateY: Math.round(this.top + this.height / 2 - h / 2 - 1) });
        }
        drawOutline(t, e, a, n) {
          let h = this.navigatorOptions.maskInside, p = this.outline.strokeWidth(), f = p / 2, m = p % 2 / 2, v = this.scrollButtonSize, A = this.size, G = this.top, R = this.height, P = G - f, j = G + R, T = this.left, W, L;
          a ? (W = G + e + m, e = G + t + m, L = [["M", T + R, G - v - m], ["L", T + R, W], ["L", T, W], ["M", T, e], ["L", T + R, e], ["L", T + R, G + A + v]], h && L.push(["M", T + R, W - f], ["L", T + R, e + f])) : (T -= v, t += T + v - m, e += T + v - m, L = [["M", T, P], ["L", t, P], ["L", t, j], ["M", e, j], ["L", e, P], ["L", T + A + 2 * v, P]], h && L.push(["M", t - f, P], ["L", e + f, P])), this.outline[n]({ d: L });
        }
        drawMasks(t, e, a, n) {
          let h, p, f, m, v = this.left, A = this.top, G = this.height;
          a ? (f = [v, v, v], m = [A, A + t, A + e], p = [G, G, G], h = [t, e - t, this.size - e]) : (f = [v, v + t, v + e], m = [A, A, A], p = [t, e - t, this.size - e], h = [G, G, G]), this.shades.forEach((R, P) => {
            R[n]({ x: f[P], y: m[P], width: p[P], height: h[P] });
          });
        }
        renderElements() {
          var v, A;
          let t = this, e = t.navigatorOptions, a = e.maskInside, n = t.chart, h = n.inverted, p = n.renderer, f = { cursor: h ? "ns-resize" : "ew-resize" }, m = (v = t.navigatorGroup) != null ? v : t.navigatorGroup = p.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!a, a, !a].forEach((G, R) => {
            var j;
            let P = (j = t.shades[R]) != null ? j : t.shades[R] = p.rect().addClass("highcharts-navigator-mask" + (R === 1 ? "-inside" : "-outside")).add(m);
            n.styledMode || (P.attr({ fill: G ? e.maskFill : "rgba(0,0,0,0)" }), R === 1 && P.css(f));
          }), t.outline || (t.outline = p.path().addClass("highcharts-navigator-outline").add(m)), n.styledMode || t.outline.attr({ "stroke-width": e.outlineWidth, stroke: e.outlineColor }), (A = e.handles) == null ? void 0 : A.enabled) {
            let G = e.handles, { height: R, width: P } = G;
            [0, 1].forEach((j) => {
              var W;
              let T = G.symbols[j];
              if (t.handles[j] && t.handles[j].symbolUrl === T) {
                if (!t.handles[j].isImg && t.handles[j].symbolName !== T) {
                  let L = M[T].call(M, -P / 2 - 1, 0, P, R);
                  t.handles[j].attr({ d: L }), t.handles[j].symbolName = T;
                }
              } else (W = t.handles[j]) == null || W.destroy(), t.handles[j] = p.symbol(T, -P / 2 - 1, 0, P, R, G), t.handles[j].attr({ zIndex: 7 - j }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][j]).add(m), t.addMouseEvents();
              n.inverted && t.handles[j].attr({ rotation: 90, rotationOriginX: Math.floor(-P / 2), rotationOriginY: (R + P) / 2 }), n.styledMode || t.handles[j].attr({ fill: G.backgroundColor, stroke: G.borderColor, "stroke-width": G.lineWidth, width: G.width, height: G.height, x: -P / 2 - 1, y: 0 }).css(f);
            });
          }
        }
        update(t, e = !1) {
          var h, p;
          let a = this.chart, n = a.options.chart.inverted !== ((h = a.scrollbar) == null ? void 0 : h.options.vertical);
          if (u(!0, a.options.navigator, t), this.navigatorOptions = a.options.navigator || {}, this.setOpposite(), k(t.enabled) || n) return this.destroy(), this.navigatorEnabled = t.enabled || this.navigatorEnabled, this.init(a);
          if (this.navigatorEnabled && (this.isDirty = !0, t.adaptToUpdatedData === !1 && this.baseSeries.forEach((f) => {
            r(f, "updatedData", this.updatedDataHandler);
          }, this), t.adaptToUpdatedData && this.baseSeries.forEach((f) => {
            f.eventsToUnbind.push(S(f, "updatedData", this.updatedDataHandler));
          }, this), (t.series || t.baseSeries) && this.setBaseSeries(void 0, !1), t.height || t.xAxis || t.yAxis)) {
            this.height = (p = t.height) != null ? p : this.height;
            let f = this.getXAxisOffsets();
            this.xAxis.update({ ...t.xAxis, offsets: f, [a.inverted ? "width" : "height"]: this.height, [a.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...t.yAxis, [a.inverted ? "width" : "height"]: this.height }, !1);
          }
          e && a.redraw();
        }
        render(t, e, a, n) {
          let h = this.chart, p = this.xAxis, f = p.pointRange || 0, m = p.navigatorAxis.fake ? h.xAxis[0] : p, v = this.navigatorEnabled, A = this.rendered, G = h.inverted, R = h.xAxis[0].minRange, P = h.xAxis[0].options.maxRange, j = this.scrollButtonSize, T, W, L, F = this.scrollbarHeight, K, X;
          if (this.hasDragged && !k(a)) return;
          if (this.isDirty && this.renderElements(), t = b(t - f / 2), e = b(e + f / 2), !d(t) || !d(e)) {
            if (!A) return;
            a = 0, n = E(p.width, m.width);
          }
          this.left = E(p.left, h.plotLeft + j + (G ? h.plotWidth : 0));
          let $ = this.size = K = E(p.len, (G ? h.plotHeight : h.plotWidth) - 2 * j);
          T = G ? F : K + 2 * j, a = E(a, p.toPixels(t, !0)), n = E(n, p.toPixels(e, !0)), d(a) && Math.abs(a) !== 1 / 0 || (a = 0, n = T);
          let Q = p.toValue(a, !0), tt = p.toValue(n, !0), et = Math.abs(b(tt - Q));
          et < R ? this.grabbedLeft ? a = p.toPixels(tt - R - f, !0) : this.grabbedRight && (n = p.toPixels(Q + R + f, !0)) : k(P) && b(et - f) > P && (this.grabbedLeft ? a = p.toPixels(tt - P - f, !0) : this.grabbedRight && (n = p.toPixels(Q + P + f, !0))), this.zoomedMax = U(Math.max(a, n), 0, $), this.zoomedMin = U(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(a, n), 0, $), this.range = this.zoomedMax - this.zoomedMin, $ = Math.round(this.zoomedMax);
          let ot = Math.round(this.zoomedMin);
          v && (this.navigatorGroup.attr({ visibility: "inherit" }), X = A && !this.hasDragged ? "animate" : "attr", this.drawMasks(ot, $, G, X), this.drawOutline(ot, $, G, X), this.navigatorOptions.handles.enabled && (this.drawHandle(ot, 0, G, X), this.drawHandle($, 1, G, X))), this.scrollbar && (G ? (L = this.top - j, W = this.left - F + (v || !m.opposite ? 0 : (m.titleOffset || 0) + m.axisTitleMargin), F = K + 2 * j) : (L = this.top + (v ? this.height : -F), W = this.left - j), this.scrollbar.position(W, L, T, F), this.scrollbar.setRange(this.zoomedMin / (K || 1), this.zoomedMax / (K || 1))), this.rendered = !0, this.isDirty = !1, y(this, "afterRender");
        }
        addMouseEvents() {
          let t = this, e = t.chart, a = e.container, n = [], h, p;
          t.mouseMoveHandler = h = function(f) {
            t.onMouseMove(f);
          }, t.mouseUpHandler = p = function(f) {
            t.onMouseUp(f);
          }, (n = t.getPartsEvents("mousedown")).push(S(e.renderTo, "mousemove", h), S(a.ownerDocument, "mouseup", p), S(e.renderTo, "touchmove", h), S(a.ownerDocument, "touchend", p)), n.concat(t.getPartsEvents("touchstart")), t.eventsToUnbind = n, t.series && t.series[0] && n.push(S(t.series[0].xAxis, "foundExtremes", function() {
            e.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(t) {
          let e = this, a = [];
          return ["shades", "handles"].forEach(function(n) {
            e[n].forEach(function(h, p) {
              a.push(S(h.element, t, function(f) {
                e[n + "Mousedown"](f, p);
              }));
            });
          }), a;
        }
        shadesMousedown(t, e) {
          var j;
          t = ((j = this.chart.pointer) == null ? void 0 : j.normalize(t)) || t;
          let a = this.chart, n = this.xAxis, h = this.zoomedMin, p = this.size, f = this.range, m = this.left, v = t.chartX, A, G, R, P;
          a.inverted && (v = t.chartY, m = this.top), e === 1 ? (this.grabbedCenter = v, this.fixedWidth = f, this.dragOffset = v - h) : (P = v - m - f / 2, e === 0 ? P = Math.max(0, P) : e === 2 && P + f >= p && (P = p - f, this.reversedExtremes ? (P -= f, G = this.getUnionExtremes().dataMin) : A = this.getUnionExtremes().dataMax), P !== h && (this.fixedWidth = f, k((R = n.navigatorAxis.toFixedRange(P, P + f, G, A)).min) && y(this, "setRange", { min: Math.min(R.min, R.max), max: Math.max(R.min, R.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(t, e) {
          var p;
          t = ((p = this.chart.pointer) == null ? void 0 : p.normalize(t)) || t;
          let a = this.chart, n = a.xAxis[0], h = this.reversedExtremes;
          e === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = h ? n.min : n.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = h ? n.max : n.min), a.setFixedRange(void 0);
        }
        onMouseMove(t) {
          var A;
          let e = this, a = e.chart, n = e.navigatorSize, h = e.range, p = e.dragOffset, f = a.inverted, m = e.left, v;
          (!t.touches || t.touches[0].pageX !== 0) && (v = (t = ((A = a.pointer) == null ? void 0 : A.normalize(t)) || t).chartX, f && (m = e.top, v = t.chartY), e.grabbedLeft ? (e.hasDragged = !0, e.render(0, 0, v - m, e.otherHandlePos)) : e.grabbedRight ? (e.hasDragged = !0, e.render(0, 0, e.otherHandlePos, v - m)) : e.grabbedCenter && (e.hasDragged = !0, v < p ? v = p : v > n + p - h && (v = n + p - h), e.render(0, 0, v - p, v - p + h)), e.hasDragged && e.scrollbar && E(e.scrollbar.options.liveRedraw, !C && !this.chart.boosted) && (t.DOMType = t.type, setTimeout(function() {
            e.onMouseUp(t);
          }, 0)));
        }
        onMouseUp(t) {
          let e, a, n, h, p, f, m = this.chart, v = this.xAxis, A = this.scrollbar, G = t.DOMEvent || t, R = m.inverted, P = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!A || !A.hasDragged) || t.trigger === "scrollbar") && (n = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? h = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (p = this.fixedExtreme), this.zoomedMax === this.size && (p = this.reversedExtremes ? n.dataMin : n.dataMax), this.zoomedMin === 0 && (h = this.reversedExtremes ? n.dataMax : n.dataMin), k((f = v.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, h, p)).min) && y(this, "setRange", { min: Math.min(f.min, f.max), max: Math.max(f.min, f.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: G } })), t.DOMType !== "mousemove" && t.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && d(this.zoomedMin) && d(this.zoomedMax) && (a = Math.round(this.zoomedMin), e = Math.round(this.zoomedMax), this.shades && this.drawMasks(a, e, R, P), this.outline && this.drawOutline(a, e, R, P), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(a, 0, R, P), this.drawHandle(e, 1, R, P)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(t) {
            t();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let t = this.baseSeries || [];
          this.navigatorEnabled && t[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && t.forEach(function(e) {
            r(e, "updatedData", this.updatedDataHandler);
          }, this), t[0].xAxis && r(t[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(t) {
          var T;
          let e = t.options, a = e.navigator || {}, n = a.enabled, h = e.scrollbar || {}, p = h.enabled, f = n && a.height || 0, m = p && h.height || 0, v = h.buttonsEnabled && m || 0;
          this.handles = [], this.shades = [], this.chart = t, this.setBaseSeries(), this.height = f, this.scrollbarHeight = m, this.scrollButtonSize = v, this.scrollbarEnabled = p, this.navigatorEnabled = n, this.navigatorOptions = a, this.scrollbarOptions = h, this.setOpposite();
          let A = this, G = A.baseSeries, R = t.xAxis.length, P = t.yAxis.length, j = G && G[0] && G[0].xAxis || t.xAxis[0] || { options: {} };
          if (t.isDirtyBox = !0, A.navigatorEnabled) {
            let W = this.getXAxisOffsets();
            A.xAxis = new D(t, u({ breaks: j.options.breaks, ordinal: j.options.ordinal, overscroll: j.options.overscroll }, a.xAxis, { type: "datetime", yAxis: (T = a.yAxis) == null ? void 0 : T.id, index: R, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: j.options.ordinal ? 0 : j.options.minPadding, maxPadding: j.options.ordinal ? 0 : j.options.maxPadding, zoomEnabled: !1 }, t.inverted ? { offsets: W, width: f } : { offsets: W, height: f }), "xAxis"), A.yAxis = new D(t, u(a.yAxis, { alignTicks: !1, offset: 0, index: P, isInternal: !0, reversed: E(a.yAxis && a.yAxis.reversed, t.yAxis[0] && t.yAxis[0].reversed, !1), zoomEnabled: !1 }, t.inverted ? { width: f } : { height: f }), "yAxis"), G || a.series.data ? A.updateNavigatorSeries(!1) : t.series.length === 0 && (A.unbindRedraw = S(t, "beforeRedraw", function() {
              t.series.length > 0 && !A.series && (A.setBaseSeries(), A.unbindRedraw());
            })), A.reversedExtremes = t.inverted && !A.xAxis.reversed || !t.inverted && A.xAxis.reversed, A.renderElements(), A.addMouseEvents();
          } else A.xAxis = { chart: t, navigatorAxis: { fake: !0 }, translate: function(W, L) {
            let F = t.xAxis[0], K = F.getExtremes(), X = F.len - 2 * v, $ = i("min", F.options.min, K.dataMin), Q = i("max", F.options.max, K.dataMax) - $;
            return L ? W * Q / X + $ : X * (W - $) / Q;
          }, toPixels: function(W) {
            return this.translate(W);
          }, toValue: function(W) {
            return this.translate(W, !0);
          } }, A.xAxis.navigatorAxis.axis = A.xAxis, A.xAxis.navigatorAxis.toFixedRange = Z.prototype.toFixedRange.bind(A.xAxis.navigatorAxis);
          if (t.options.scrollbar.enabled) {
            let W = u(t.options.scrollbar, { vertical: t.inverted });
            !d(W.margin) && A.navigatorEnabled && (W.margin = t.inverted ? -3 : 3), t.scrollbar = A.scrollbar = new N(t.renderer, W, t), S(A.scrollbar, "changed", function(L) {
              let F = A.size, K = F * this.to, X = F * this.from;
              A.hasDragged = A.scrollbar.hasDragged, A.render(0, 0, X, K), this.shouldUpdateExtremes(L.DOMType) && setTimeout(function() {
                A.onMouseUp(L);
              });
            });
          }
          A.addBaseSeriesEvents(), A.addChartEvents();
        }
        setOpposite() {
          let t = this.navigatorOptions, e = this.navigatorEnabled, a = this.chart;
          this.opposite = E(t.opposite, !!(!e && a.inverted));
        }
        getUnionExtremes(t) {
          let e, a = this.chart.xAxis[0], n = this.xAxis, h = n.options, p = a.options;
          return t && a.dataMin === null || (e = { dataMin: E(h && h.min, i("min", p.min, a.dataMin, n.dataMin, n.min)), dataMax: E(h && h.max, i("max", p.max, a.dataMax, n.dataMax, n.max)) }), e;
        }
        setBaseSeries(t, e) {
          let a = this.chart, n = this.baseSeries = [];
          t = t || a.options && a.options.navigator.baseSeries || (a.series.length ? g(a.series, (h) => !h.options.isInternal).index : 0), (a.series || []).forEach((h, p) => {
            !h.options.isInternal && (h.options.showInNavigator || (p === t || h.options.id === t) && h.options.showInNavigator !== !1) && n.push(h);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, e);
        }
        updateNavigatorSeries(t, e) {
          var R, P;
          let a = this, n = a.chart, h = a.baseSeries, p = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (R = this.navigatorOptions.xAxis) == null ? void 0 : R.id, yAxis: (P = this.navigatorOptions.yAxis) == null ? void 0 : P.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, f = a.series = (a.series || []).filter((j) => {
            let T = j.baseSeries;
            return !(0 > h.indexOf(T)) || (T && (r(T, "updatedData", a.updatedDataHandler), delete T.navigatorSeries), j.chart && j.destroy(), !1);
          }), m, v, A = a.navigatorOptions.series, G;
          h && h.length && h.forEach((j) => {
            let T = j.navigatorSeries, W = w({ color: j.color, visible: j.visible }, B(A) ? _.navigator.series : A);
            if (T && a.navigatorOptions.adaptToUpdatedData === !1) return;
            p.name = "Navigator " + h.length, G = (m = j.options || {}).navigatorOptions || {}, W.dataLabels = o(W.dataLabels), (v = u(m, p, W, G)).pointRange = E(W.pointRange, G.pointRange, _.plotOptions[v.type || "line"].pointRange);
            let L = G.data || W.data;
            a.hasNavigatorData = a.hasNavigatorData || !!L, v.data = L || m.data && m.data.slice(0), T && T.options ? T.update(v, e) : (j.navigatorSeries = n.initSeries(v), n.setSortedData(), j.navigatorSeries.baseSeries = j, f.push(j.navigatorSeries));
          }), (A.data && !(h && h.length) || B(A)) && (a.hasNavigatorData = !1, (A = o(A)).forEach((j, T) => {
            p.name = "Navigator " + (f.length + 1), (v = u(_.navigator.series, { color: n.series[T] && !n.series[T].options.isInternal && n.series[T].color || n.options.colors[T] || n.options.colors[0] }, p, j)).data = j.data, v.data && (a.hasNavigatorData = !0, f.push(n.initSeries(v)));
          })), t && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let t = this, e = t.baseSeries || [];
          e[0] && e[0].xAxis && e[0].eventsToUnbind.push(S(e[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), e.forEach((a) => {
            a.eventsToUnbind.push(S(a, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), a.eventsToUnbind.push(S(a, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && a.xAxis && a.eventsToUnbind.push(S(a, "updatedData", this.updatedDataHandler)), a.eventsToUnbind.push(S(a, "remove", function() {
              e && c(e, a), this.navigatorSeries && (c(t.series, this.navigatorSeries), k(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(t) {
          return this.baseSeries.reduce(function(e, a) {
            return Math.min(e, a.xData && a.xData.length ? a.xData[0] : e);
          }, t);
        }
        modifyNavigatorAxisExtremes() {
          let t = this.xAxis;
          if (t.getExtremes !== void 0) {
            let e = this.getUnionExtremes(!0);
            e && (e.dataMin !== t.min || e.dataMax !== t.max) && (t.min = e.dataMin, t.max = e.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var T;
          let t, e, a = this.chart.navigator, n = this.getExtremes(), h = n.min, p = n.max, f = n.dataMin, m = n.dataMax, v = p - h, A = a.stickToMin, G = a.stickToMax, R = E((T = this.ordinal) == null ? void 0 : T.convertOverscroll(this.options.overscroll), 0), P = a.series && a.series[0], j = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (A && (t = (e = f) + v), G && (t = m + R, A || (e = Math.max(f, t - v, a.getBaseSeriesMin(P && P.xData ? P.xData[0] : -Number.MAX_VALUE)))), j && (A || G) && d(e) && (this.min = this.userMin = e, this.max = this.userMax = t)), a.stickToMin = a.stickToMax = null;
        }
        updatedDataHandler() {
          let t = this.chart.navigator, e = this.navigatorSeries, a = t.reversedExtremes ? Math.round(t.zoomedMin) === 0 : Math.round(t.zoomedMax) >= Math.round(t.size);
          t.stickToMax = E(this.chart.options.navigator && this.chart.options.navigator.stickToMax, a), t.stickToMin = t.shouldStickToMin(this, t), e && !t.hasNavigatorData && (e.options.pointStart = this.xData[0], e.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(t, e) {
          let a = e.getBaseSeriesMin(t.xData[0]), n = t.xAxis, h = n.max, p = n.min, f = n.options.range;
          return !!(d(h) && d(p)) && (f && h - a > 0 ? h - a < f : p <= a);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(S(this.chart, "redraw", function() {
            let t = this.navigator, e = t && (t.baseSeries && t.baseSeries[0] && t.baseSeries[0].xAxis || this.xAxis[0]);
            e && t.render(e.min, e.max);
          }), S(this.chart, "getMargins", function() {
            let t = this.navigator, e = t.opposite ? "plotTop" : "marginBottom";
            this.inverted && (e = t.opposite ? "marginRight" : "plotLeft"), this[e] = (this[e] || 0) + (t.navigatorEnabled || !this.inverted ? t.height + t.scrollbarHeight : 0) + t.navigatorOptions.margin;
          }), S(s, "setRange", function(t) {
            this.chart.xAxis[0].setExtremes(t.min, t.max, t.redraw, t.animation, t.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (c(this.chart.xAxis, this.xAxis), c(this.chart.axes, this.xAxis)), this.yAxis && (c(this.chart.yAxis, this.yAxis), c(this.chart.axes, this.yAxis)), (this.series || []).forEach((t) => {
            t.destroy && t.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((t) => {
            this[t] && this[t].destroy && this[t].destroy(), this[t] = null;
          }), [this.handles].forEach((t) => {
            O(t);
          }), this.navigatorEnabled = !1;
        }
      }
      return s;
    }), J(x, "Core/Axis/OrdinalAxis.js", [x["Core/Axis/Axis.js"], x["Core/Globals.js"], x["Core/Series/Series.js"], x["Core/Utilities.js"]], function(D, H, Y, V) {
      var Z;
      let { addEvent: q, correctFloat: N, css: I, defined: z, error: _, isNumber: C, pick: M, timeUnits: S, isString: U } = V;
      return function(b) {
        function k(i, s, l, t, e = [], a = 0, n) {
          let h = {}, p = this.options.tickPixelInterval, f = this.chart.time, m = [], v, A, G, R, P, j = 0, T = [], W = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !e || e.length < 3 || s === void 0) return f.getTimeTicks.apply(f, arguments);
          let L = e.length;
          for (v = 0; v < L; v++) {
            if (P = v && e[v - 1] > l, e[v] < s && (j = v), v === L - 1 || e[v + 1] - e[v] > 5 * a || P) {
              if (e[v] > W) {
                for (A = f.getTimeTicks(i, e[j], e[v], t); A.length && A[0] <= W; ) A.shift();
                A.length && (W = A[A.length - 1]), m.push(T.length), T = T.concat(A);
              }
              j = v + 1;
            }
            if (P) break;
          }
          if (A) {
            if (R = A.info, n && R.unitRange <= S.hour) {
              for (j = 1, v = T.length - 1; j < v; j++) f.dateFormat("%d", T[j]) !== f.dateFormat("%d", T[j - 1]) && (h[T[j]] = "day", G = !0);
              G && (h[T[0]] = "day"), R.higherRanks = h;
            }
            R.segmentStarts = m, T.info = R;
          } else _(12, !1, this.chart);
          if (n && z(p)) {
            let F = T.length, K = [], X = [], $, Q, tt, et, ot, it = F;
            for (; it--; ) Q = this.translate(T[it]), tt && (X[it] = tt - Q), K[it] = tt = Q;
            for (X.sort((rt, lt) => rt - lt), (et = X[Math.floor(X.length / 2)]) < 0.6 * p && (et = null), it = T[F - 1] > l ? F - 1 : F, tt = void 0; it--; ) ot = Math.abs(tt - (Q = K[it])), tt && ot < 0.8 * p && (et === null || ot < 0.8 * et) ? (h[T[it]] && !h[T[it + 1]] ? ($ = it + 1, tt = Q) : $ = it, T.splice($, 1)) : tt = Q;
          }
          return T;
        }
        function O(i) {
          let s = this.ordinal.positions;
          if (!s) return i;
          let l = s.length - 1, t;
          return i < 0 ? i = s[0] : i > l ? i = s[l] : (l = Math.floor(i), t = i - l), t !== void 0 && s[l] !== void 0 ? s[l] + (t ? t * (s[l + 1] - s[l]) : 0) : i;
        }
        function c(i) {
          let s = this.ordinal, l = this.old ? this.old.min : this.min, t = this.old ? this.old.transA : this.transA, e = s.getExtendedPositions();
          if (e && e.length) {
            let a = N((i - l) * t + this.minPixelPadding), n = N(s.getIndexOfPoint(a, e)), h = N(n % 1);
            if (n >= 0 && n <= e.length - 1) {
              let p = e[Math.floor(n)], f = e[Math.ceil(n)];
              return e[Math.floor(n)] + h * (f - p);
            }
          }
          return i;
        }
        function w(i, s) {
          let l = b.Additions.findIndexOf(i, s, !0);
          if (i[l] === s) return l;
          let t = (s - i[l]) / (i[l + 1] - i[l]);
          return l + t;
        }
        function g() {
          this.ordinal || (this.ordinal = new b.Additions(this));
        }
        function y() {
          let { eventArgs: i, options: s } = this;
          if (this.isXAxis && z(s.overscroll) && s.overscroll !== 0 && C(this.max) && C(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(!1), this.max === this.dataMax && ((i == null ? void 0 : i.trigger) !== "pan" || this.isInternal) && (i == null ? void 0 : i.trigger) !== "navigator")) {
            let l = this.ordinal.convertOverscroll(s.overscroll);
            this.max += l, !this.isInternal && z(this.userMin) && (i == null ? void 0 : i.trigger) !== "mousewheel" && (this.min += l);
          }
        }
        function B() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function d() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function u(i) {
          let s = this.xAxis[0], l = s.ordinal.convertOverscroll(s.options.overscroll), t = i.originalEvent.chartX, e = this.options.chart.panning, a = !1;
          if (e && e.type !== "y" && s.options.ordinal && s.series.length && (!i.touches || i.touches.length <= 1)) {
            let n, h, p = this.mouseDownX, f = s.getExtremes(), m = f.dataMin, v = f.dataMax, A = f.min, G = f.max, R = this.hoverPoints, P = s.closestPointRange || s.ordinal && s.ordinal.overscrollPointsRange, j = Math.round((p - t) / (s.translationSlope * (s.ordinal.slope || P))), T = s.ordinal.getExtendedPositions(), W = { ordinal: { positions: T, extendedOrdinalPositions: T } }, L = s.index2val, F = s.val2lin;
            if (A <= m && j < 0 || G + l >= v && j > 0) return;
            W.ordinal.positions ? Math.abs(j) > 1 && (R && R.forEach(function(K) {
              K.setState();
            }), v > (h = W.ordinal.positions)[h.length - 1] && h.push(v), this.setFixedRange(G - A), (n = s.navigatorAxis.toFixedRange(void 0, void 0, L.apply(W, [F.apply(W, [A, !0]) + j]), L.apply(W, [F.apply(W, [G, !0]) + j]))).min >= Math.min(f.dataMin, A) && n.max <= Math.max(v, G) + l && s.setExtremes(n.min, n.max, !0, !1, { trigger: "pan" }), this.mouseDownX = t, I(this.container, { cursor: "move" })) : a = !0;
          } else a = !0;
          a || e && /y/.test(e.type) ? l && (s.max = s.dataMax + l) : i.preventDefault();
        }
        function E() {
          let i = this.xAxis;
          i && i.options.ordinal && (delete i.ordinal.index, delete i.ordinal.originalOrdinalRange);
        }
        function r(i, s) {
          let l, t = this.ordinal, e = t.positions, a = t.slope, n;
          if (!e) return i;
          let h = e.length;
          if (e[0] <= i && e[h - 1] >= i) l = w(e, i);
          else {
            if (!((n = t.getExtendedPositions && t.getExtendedPositions()) && n.length)) return i;
            let p = n.length;
            a || (a = (n[p - 1] - n[0]) / p);
            let f = w(n, e[0]);
            if (i >= n[0] && i <= n[p - 1]) l = w(n, i) - f;
            else {
              if (!s) return i;
              l = i < n[0] ? -f - (n[0] - i) / a : (i - n[p - 1]) / a + p - f;
            }
          }
          return s ? l : a * (l || 0) + t.offset;
        }
        b.compose = function(i, s, l) {
          let t = i.prototype;
          return t.ordinal2lin || (t.getTimeTicks = k, t.index2val = O, t.lin2val = c, t.val2lin = r, t.ordinal2lin = t.val2lin, q(i, "afterInit", g), q(i, "foundExtremes", y), q(i, "afterSetScale", B), q(i, "initialAxisTranslation", d), q(l, "pan", u), q(l, "touchpan", u), q(s, "updatedData", E)), i;
        };
        class o {
          constructor(s) {
            this.index = {}, this.axis = s;
          }
          beforeSetTickPositions() {
            var F;
            let s = this.axis, l = s.ordinal, t = s.getExtremes(), e = t.min, a = t.max, n = (F = s.brokenAxis) == null ? void 0 : F.hasBreaks, h = s.options.ordinal, p, f, m, v, A, G, R, P = [], j = Number.MAX_VALUE, T = !1, W = !1, L = !1;
            if (h || n) {
              let K = 0;
              if (s.series.forEach(function(X, $) {
                if (f = [], $ > 0 && X.options.id !== "highcharts-navigator-series" && X.processedXData.length > 1 && (W = K !== X.processedXData[1] - X.processedXData[0]), K = X.processedXData[1] - X.processedXData[0], X.boosted && (L = X.boosted), X.reserveSpace() && (X.takeOrdinalPosition !== !1 || n) && (p = (P = P.concat(X.processedXData)).length, P.sort(function(Q, tt) {
                  return Q - tt;
                }), j = Math.min(j, M(X.closestPointRange, j)), p)) {
                  for ($ = 0; $ < p - 1; ) P[$] !== P[$ + 1] && f.push(P[$ + 1]), $++;
                  f[0] !== P[0] && f.unshift(P[0]), P = f;
                }
              }), s.ordinal.originalOrdinalRange || (s.ordinal.originalOrdinalRange = (P.length - 1) * j), W && L && (P.pop(), P.shift()), (p = P.length) > 2) {
                for (m = P[1] - P[0], R = p - 1; R-- && !T; ) P[R + 1] - P[R] !== m && (T = !0);
                !s.options.keepOrdinalPadding && (P[0] - e > m || a - P[P.length - 1] > m) && (T = !0);
              } else s.options.overscroll && (p === 2 ? j = P[1] - P[0] : p === 1 ? (j = s.ordinal.convertOverscroll(s.options.overscroll), P = [P[0], P[0] + j]) : j = l.overscrollPointsRange);
              T || s.forceOrdinal ? (s.options.overscroll && (l.overscrollPointsRange = j, P = P.concat(l.getOverscrollPositions())), l.positions = P, v = s.ordinal2lin(Math.max(e, P[0]), !0), A = Math.max(s.ordinal2lin(Math.min(a, P[P.length - 1]), !0), 1), l.slope = G = (a - e) / (A - v), l.offset = e - v * G) : (l.overscrollPointsRange = M(s.closestPointRange, l.overscrollPointsRange), l.positions = s.ordinal.slope = l.offset = void 0);
            }
            s.isOrdinal = h && T, l.groupIntervalFactor = null;
          }
          static findIndexOf(s, l, t) {
            let e = 0, a = s.length - 1, n;
            for (; e < a; ) s[n = Math.ceil((e + a) / 2)] <= l ? e = n : a = n - 1;
            return s[e] === l || t ? e : -1;
          }
          getExtendedPositions(s = !0) {
            var G;
            let l = this, t = l.axis, e = t.constructor.prototype, a = t.chart, n = (G = t.series[0]) == null ? void 0 : G.currentDataGrouping, h = n ? n.count + n.unitName : "raw", p = s ? t.ordinal.convertOverscroll(t.options.overscroll) : 0, f = t.getExtremes(), m, v, A = l.index;
            return A || (A = l.index = {}), A[h] || ((m = { series: [], chart: a, forceOrdinal: !1, getExtremes: function() {
              return { min: f.dataMin, max: f.dataMax + p };
            }, applyGrouping: e.applyGrouping, getGroupPixelWidth: e.getGroupPixelWidth, getTimeTicks: e.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: e.ordinal2lin, getIndexOfPoint: e.getIndexOfPoint, val2lin: e.val2lin }).ordinal.axis = m, t.series.forEach(function(R) {
              var P, j, T;
              v = { xAxis: m, xData: R.xData.slice(), chart: a, groupPixelWidth: R.groupPixelWidth, destroyGroupedData: H.noop, getProcessedData: Y.prototype.getProcessedData, applyGrouping: Y.prototype.applyGrouping, reserveSpace: Y.prototype.reserveSpace, visible: R.visible }, s && (v.xData = v.xData.concat(l.getOverscrollPositions())), v.options = { dataGrouping: n ? { firstAnchor: (P = R.options.dataGrouping) == null ? void 0 : P.firstAnchor, anchor: (j = R.options.dataGrouping) == null ? void 0 : j.anchor, lastAnchor: (T = R.options.dataGrouping) == null ? void 0 : T.firstAnchor, enabled: !0, forced: !0, approximation: "open", units: [[n.unitName, [n.count]]] } : { enabled: !1 } }, m.series.push(v), R.processData.apply(v);
            }), m.applyGrouping({ hasExtremesChanged: !0 }), (v == null ? void 0 : v.closestPointRange) !== (v == null ? void 0 : v.basePointRange) && v.currentDataGrouping && (m.forceOrdinal = !0), t.ordinal.beforeSetTickPositions.apply({ axis: m }), !t.ordinal.originalOrdinalRange && m.ordinal.originalOrdinalRange && (t.ordinal.originalOrdinalRange = m.ordinal.originalOrdinalRange), A[h] = m.ordinal.positions), A[h];
          }
          getGroupIntervalFactor(s, l, t) {
            let e = t.processedXData, a = e.length, n = [], h, p, f = this.groupIntervalFactor;
            if (!f) {
              for (p = 0; p < a - 1; p++) n[p] = e[p + 1] - e[p];
              n.sort(function(m, v) {
                return m - v;
              }), h = n[Math.floor(a / 2)], s = Math.max(s, e[0]), l = Math.min(l, e[a - 1]), this.groupIntervalFactor = f = a * h / (l - s);
            }
            return f;
          }
          getIndexOfPoint(s, l) {
            let t, e = this.axis, a = 0, n = function(f) {
              let { min: m, max: v } = e;
              return !!(z(m) && z(v)) && f.points.some((A) => A.x >= m && A.x <= v);
            };
            e.series.forEach((f) => {
              var v;
              let m = (v = f.points) == null ? void 0 : v[0];
              z(m == null ? void 0 : m.plotX) && (m.plotX < t || !z(t)) && n(f) && (t = m.plotX, a = m.x);
            }), t != null || (t = e.minPixelPadding);
            let h = e.translationSlope * (this.slope || e.closestPointRange || this.overscrollPointsRange), p = N((s - t) / h);
            return o.findIndexOf(l, a, !0) + p;
          }
          getOverscrollPositions() {
            let s = this.axis, l = this.convertOverscroll(s.options.overscroll), t = this.overscrollPointsRange, e = [], a = s.dataMax;
            if (z(t)) for (; a <= s.dataMax + l; ) e.push(a += t);
            return e;
          }
          postProcessTickInterval(s) {
            let l = this.axis, t = this.slope;
            return t ? l.options.breaks ? l.closestPointRange || s : s / (t / l.closestPointRange) : s;
          }
          convertOverscroll(s = 0) {
            let l = this, t = l.axis, e = function(a) {
              return M(l.originalOrdinalRange, z(t.dataMax) && z(t.dataMin) ? t.dataMax - t.dataMin : 0) * a;
            };
            if (U(s)) {
              let a = parseInt(s, 10);
              if (/%$/.test(s)) return e(a / 100);
              if (/px/.test(s)) {
                let n = Math.min(a, 0.9 * t.len) / t.len;
                return e(n / (1 - n));
              }
              return 0;
            }
            return s;
          }
        }
        b.Additions = o;
      }(Z || (Z = {})), Z;
    }), J(x, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
      return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
    }), J(x, "Stock/RangeSelector/RangeSelectorComposition.js", [x["Core/Defaults.js"], x["Core/Globals.js"], x["Stock/RangeSelector/RangeSelectorDefaults.js"], x["Core/Utilities.js"]], function(D, H, Y, V) {
      let Z, { defaultOptions: q } = D, { composed: N } = H, { addEvent: I, defined: z, extend: _, isNumber: C, merge: M, pick: S, pushUnique: U } = V, b = [];
      function k() {
        let d, u, E = this.range, r = E.type, o = this.max, i = this.chart.time, s = function(t, e) {
          let a = r === "year" ? "FullYear" : "Month", n = new i.Date(t), h = i.get(a, n);
          return i.set(a, n, h + e), h === i.get(a, n) && i.set("Date", n, 0), n.getTime() - t;
        };
        C(E) ? (d = o - E, u = E) : E && (d = o + s(o, -(E.count || 1)), this.chart && this.chart.setFixedRange(o - d));
        let l = S(this.dataMin, Number.MIN_VALUE);
        return C(d) || (d = l), d <= l && (d = l, u === void 0 && (u = s(d, E.count)), this.newMax = Math.min(d + u, S(this.dataMax, Number.MAX_VALUE))), C(o) ? !C(E) && E && E._offsetMin && (d += E._offsetMin) : d = void 0, d;
      }
      function O() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new Z(this));
      }
      function c() {
        let d = this.rangeSelector;
        if (d) {
          C(d.deferredYTDClick) && (d.clickButton(d.deferredYTDClick), delete d.deferredYTDClick);
          let u = d.options.verticalAlign;
          d.options.floating || (u === "bottom" ? this.extraBottomMargin = !0 : u === "middle" || (this.extraTopMargin = !0));
        }
      }
      function w() {
        let d, u = this.rangeSelector;
        if (!u) return;
        let E = this.xAxis[0].getExtremes(), r = this.legend, o = u && u.options.verticalAlign;
        C(E.min) && u.render(E.min, E.max), r.display && o === "top" && o === r.options.verticalAlign && (d = M(this.spacingBox), r.options.layout === "vertical" ? d.y = this.plotTop : d.y += u.getHeight(), r.group.placed = !1, r.align(d));
      }
      function g() {
        for (let d = 0, u = b.length; d < u; ++d) {
          let E = b[d];
          if (E[0] === this) {
            E[1].forEach((r) => r()), b.splice(d, 1);
            return;
          }
        }
      }
      function y() {
        let d = this.rangeSelector;
        if (d) {
          let u = d.getHeight();
          this.extraTopMargin && (this.plotTop += u), this.extraBottomMargin && (this.marginBottom += u);
        }
      }
      function B(d) {
        let u = d.options.rangeSelector, E = this.extraBottomMargin, r = this.extraTopMargin, o = this.rangeSelector;
        if (u && u.enabled && !z(o) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = o = new Z(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, o) {
          let i = u && u.verticalAlign || o.options && o.options.verticalAlign;
          o.options.floating || (i === "bottom" ? this.extraBottomMargin = !0 : i === "middle" || (this.extraTopMargin = !0)), (this.extraBottomMargin !== E || this.extraTopMargin !== r) && (this.isDirtyBox = !0);
        }
      }
      return { compose: function(d, u, E) {
        if (Z = E, U(N, "RangeSelector")) {
          let r = u.prototype;
          d.prototype.minFromRange = k, I(u, "afterGetContainer", O), I(u, "beforeRender", c), I(u, "destroy", g), I(u, "getMargins", y), I(u, "redraw", w), I(u, "update", B), r.callbacks.push(w), _(q, { rangeSelector: Y.rangeSelector }), _(q.lang, Y.lang);
        }
      } };
    }), J(x, "Stock/RangeSelector/RangeSelector.js", [x["Core/Axis/Axis.js"], x["Core/Defaults.js"], x["Core/Globals.js"], x["Stock/RangeSelector/RangeSelectorComposition.js"], x["Core/Renderer/SVG/SVGElement.js"], x["Core/Utilities.js"], x["Core/Axis/OrdinalAxis.js"]], function(D, H, Y, V, Z, q, N) {
      let { defaultOptions: I } = H, { addEvent: z, createElement: _, css: C, defined: M, destroyObjectProperties: S, discardElement: U, extend: b, fireEvent: k, isNumber: O, merge: c, objectEach: w, pad: g, pick: y, pInt: B, splat: d } = q;
      class u {
        static compose(r, o) {
          V.compose(r, o, u);
        }
        constructor(r) {
          this.buttonOptions = u.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(r);
        }
        clickButton(r, o) {
          let i = this.chart, s = this.buttonOptions[r], l = i.xAxis[0], t = i.scroller && i.scroller.getUnionExtremes() || l || {}, e = s.type, a = s.dataGrouping, n = t.dataMin, h = t.dataMax, p, f = l && Math.round(Math.min(l.max, y(h, l.max))), m, v = s._range, A, G, R, P = !0;
          if (n !== null && h !== null) {
            if (this.setSelected(r), a && (this.forcedDataGrouping = !0, D.prototype.setDataGrouping.call(l || { chart: this.chart }, a, !1), this.frozenStates = s.preserveDataGrouping), e === "month" || e === "year") l ? (G = { range: s, max: f, chart: i, dataMin: n, dataMax: h }, p = l.minFromRange.call(G), O(G.newMax) && (f = G.newMax), P = !1) : v = s;
            else if (v) f = Math.min((p = Math.max(f - v, n)) + v, h), P = !1;
            else if (e === "ytd")
              if (l) (h === void 0 || n === void 0) && (n = Number.MAX_VALUE, h = Number.MIN_VALUE, i.series.forEach((j) => {
                let T = j.xData;
                T && (n = Math.min(T[0], n), h = Math.max(T[T.length - 1], h));
              }), o = !1), p = A = (R = this.getYTDExtremes(h, n, i.time.useUTC)).min, f = R.max;
              else {
                this.deferredYTDClick = r;
                return;
              }
            else e === "all" && l && (i.navigator && i.navigator.baseSeries[0] && (i.navigator.baseSeries[0].xAxis.options.range = void 0), p = n, f = h);
            if (P && s._offsetMin && M(p) && (p += s._offsetMin), s._offsetMax && M(f) && (f += s._offsetMax), this.dropdown && (this.dropdown.selectedIndex = r + 1), l) l.setExtremes(p, f, y(o, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: s }), i.setFixedRange(s._range);
            else {
              m = d(i.options.xAxis)[0];
              let j = z(i, "afterGetAxes", function() {
                let T = i.xAxis[0];
                T.range = T.options.range = v, T.min = T.options.min = A;
              });
              z(i, "load", function() {
                let T = i.xAxis[0];
                i.setFixedRange(s._range), T.options.range = m.range, T.options.min = m.min, j();
              });
            }
            k(this, "afterBtnClick");
          }
        }
        setSelected(r) {
          this.selected = this.options.selected = r;
        }
        init(r) {
          let o = this, i = r.options.rangeSelector, s = i.buttons || o.defaultButtons.slice(), l = i.selected, t = function() {
            let e = o.minInput, a = o.maxInput;
            e && e.blur && k(e, "blur"), a && a.blur && k(a, "blur");
          };
          o.chart = r, o.options = i, o.buttons = [], o.buttonOptions = s, this.eventsToUnbind = [], this.eventsToUnbind.push(z(r.container, "mousedown", t)), this.eventsToUnbind.push(z(r, "resize", t)), s.forEach(o.computeButtonRange), l !== void 0 && s[l] && this.clickButton(l, !1), this.eventsToUnbind.push(z(r, "load", function() {
            r.xAxis && r.xAxis[0] && z(r.xAxis[0], "setExtremes", function(e) {
              O(this.max) && O(this.min) && this.max - this.min !== r.fixedRange && e.trigger !== "rangeSelectorButton" && e.trigger !== "updatedData" && o.forcedDataGrouping && !o.frozenStates && this.setDataGrouping(!1, !1);
            });
          })), this.createElements();
        }
        updateButtonStates() {
          let r = this, o = this.chart, i = this.dropdown, s = this.dropdownLabel, l = o.xAxis[0], t = Math.round(l.max - l.min), e = !l.hasVisibleSeries, a = 24 * 36e5, n = o.scroller && o.scroller.getUnionExtremes() || l, h = n.dataMin, p = n.dataMax, f = r.getYTDExtremes(p, h, o.time.useUTC), m = f.min, v = f.max, A = r.selected, G = r.options.allButtonsEnabled, R = Array(r.buttonOptions.length).fill(0), P = O(A), j = r.buttons, T = !1, W = null;
          r.buttonOptions.forEach((L, F) => {
            var ht;
            let K = L._range, X = L.type, $ = L.count || 1, Q = L._offsetMax - L._offsetMin, tt = F === A, et = K > p - h, ot = K < l.minRange, it = !1, rt = K === t;
            if (tt && et && (T = !0), l.isOrdinal && ((ht = l.ordinal) == null ? void 0 : ht.positions) && K && t < K) {
              let at = l.ordinal.positions, nt = N.Additions.findIndexOf(at, l.min, !0), ut = Math.min(N.Additions.findIndexOf(at, l.max, !0) + 1, at.length - 1);
              at[ut] - at[nt] > K && (rt = !0);
            } else (X === "month" || X === "year") && t + 36e5 >= { month: 28, year: 365 }[X] * a * $ - Q && t - 36e5 <= { month: 31, year: 366 }[X] * a * $ + Q ? rt = !0 : X === "ytd" ? (rt = v - m + Q === t, it = !tt) : X === "all" && (rt = l.max - l.min >= p - h);
            let lt = !G && !(T && X === "all") && (et || ot || e), pt = T && X === "all" || !it && rt || tt && r.frozenStates;
            lt ? R[F] = 3 : pt && (!P || F === A) && (W = F);
          }), W !== null ? (R[W] = 2, r.setSelected(W)) : (r.setSelected(), s && (s.setState(0), s.attr({ text: (I.lang.rangeSelectorZoom || "") + " ▾" })));
          for (let L = 0; L < R.length; L++) {
            let F = R[L], K = j[L];
            if (K.state !== F && (K.setState(F), i)) {
              i.options[L + 1].disabled = F === 3, F === 2 && (s && (s.setState(2), s.attr({ text: r.buttonOptions[L].text + " ▾" })), i.selectedIndex = L + 1);
              let X = s.getBBox();
              C(i, { width: `${X.width}px`, height: `${X.height}px` });
            }
          }
        }
        computeButtonRange(r) {
          let o = r.type, i = r.count || 1, s = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
          s[o] ? r._range = s[o] * i : (o === "month" || o === "year") && (r._range = 24 * { month: 30, year: 365 }[o] * 36e5 * i), r._offsetMin = y(r.offsetMin, 0), r._offsetMax = y(r.offsetMax, 0), r._range += r._offsetMax - r._offsetMin;
        }
        getInputValue(r) {
          let o = r === "min" ? this.minInput : this.maxInput, i = this.chart.options.rangeSelector, s = this.chart.time;
          return o ? (o.type === "text" && i.inputDateParser || this.defaultInputDateParser)(o.value, s.useUTC, s) : 0;
        }
        setInputValue(r, o) {
          let i = this.options, s = this.chart.time, l = r === "min" ? this.minInput : this.maxInput, t = r === "min" ? this.minDateBox : this.maxDateBox;
          if (l) {
            let e = l.getAttribute("data-hc-time"), a = M(e) ? Number(e) : void 0;
            if (M(o)) {
              let n = a;
              M(n) && l.setAttribute("data-hc-time-previous", n), l.setAttribute("data-hc-time", o), a = o;
            }
            l.value = s.dateFormat(this.inputTypeFormats[l.type] || i.inputEditDateFormat, a), t && t.attr({ text: s.dateFormat(i.inputDateFormat, a) });
          }
        }
        setInputExtremes(r, o, i) {
          let s = r === "min" ? this.minInput : this.maxInput;
          if (s) {
            let l = this.inputTypeFormats[s.type], t = this.chart.time;
            if (l) {
              let e = t.dateFormat(l, o);
              s.min !== e && (s.min = e);
              let a = t.dateFormat(l, i);
              s.max !== a && (s.max = a);
            }
          }
        }
        showInput(r) {
          let o = r === "min" ? this.minDateBox : this.maxDateBox, i = r === "min" ? this.minInput : this.maxInput;
          if (i && o && this.inputGroup) {
            let s = i.type === "text", { translateX: l = 0, translateY: t = 0 } = this.inputGroup, { x: e = 0, width: a = 0, height: n = 0 } = o, { inputBoxWidth: h } = this.options;
            C(i, { width: s ? a + (h ? -2 : 20) + "px" : "auto", height: n - 2 + "px", border: "2px solid silver" }), s && h ? C(i, { left: l + e + "px", top: t + "px" }) : C(i, { left: Math.min(Math.round(e + l - (i.offsetWidth - a) / 2), this.chart.chartWidth - i.offsetWidth) + "px", top: t - (i.offsetHeight - n) / 2 + "px" });
          }
        }
        hideInput(r) {
          let o = r === "min" ? this.minInput : this.maxInput;
          o && C(o, { top: "-9999em", border: 0, width: "1px", height: "1px" });
        }
        defaultInputDateParser(r, o, i) {
          let s = r.split("/").join("-").split(" ").join("T");
          if (s.indexOf("T") === -1 && (s += "T00:00"), o) s += "Z";
          else {
            let t;
            if (Y.isSafari && !((t = s).length > 6 && (t.lastIndexOf("-") === t.length - 6 || t.lastIndexOf("+") === t.length - 6))) {
              let e = new Date(s).getTimezoneOffset() / 60;
              s += e <= 0 ? `+${g(-e)}:00` : `-${g(e)}:00`;
            }
          }
          let l = Date.parse(s);
          if (!O(l)) {
            let t = r.split("-");
            l = Date.UTC(B(t[0]), B(t[1]) - 1, B(t[2]));
          }
          return i && o && O(l) && (l += i.getTimezoneOffset(l)), l;
        }
        drawInput(r) {
          let { chart: o, div: i, inputGroup: s } = this, l = this, t = o.renderer.style || {}, e = o.renderer, a = o.options.rangeSelector, n = I.lang, h = r === "min";
          function p(R) {
            var $;
            let { maxInput: P, minInput: j } = l, T = o.xAxis[0], W = (($ = o.scroller) == null ? void 0 : $.getUnionExtremes()) || T, L = W.dataMin, F = W.dataMax, K = o.xAxis[0].getExtremes()[R], X = l.getInputValue(R);
            O(X) && X !== K && (h && P && O(L) ? X > Number(P.getAttribute("data-hc-time")) ? X = void 0 : X < L && (X = L) : j && O(F) && (X < Number(j.getAttribute("data-hc-time")) ? X = void 0 : X > F && (X = F)), X !== void 0 && T.setExtremes(h ? X : T.min, h ? T.max : X, void 0, void 0, { trigger: "rangeSelectorInput" }));
          }
          let f = n[h ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", m = e.label(f, 0).addClass("highcharts-range-label").attr({ padding: f ? 2 : 0, height: f ? a.inputBoxHeight : 0 }).add(s), v = e.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: a.inputBoxWidth, height: a.inputBoxHeight, "text-align": "center" }).on("click", function() {
            l.showInput(r), l[r + "Input"].focus();
          });
          o.styledMode || v.attr({ stroke: a.inputBoxBorderColor, "stroke-width": 1 }), v.add(s);
          let A = _("input", { name: r, className: "highcharts-range-selector" }, void 0, i);
          A.setAttribute("type", function(R) {
            if (R.indexOf("%L") !== -1) return "text";
            let P = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some((T) => R.indexOf("%" + T) !== -1), j = ["H", "k", "I", "l", "M", "S"].some((T) => R.indexOf("%" + T) !== -1);
            return P && j ? "datetime-local" : P ? "date" : j ? "time" : "text";
          }(a.inputDateFormat || "%e %b %Y")), o.styledMode || (m.css(c(t, a.labelStyle)), v.css(c({ color: "#333333" }, t, a.inputStyle)), C(A, b({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: t.fontSize, fontFamily: t.fontFamily, top: "-9999em" }, a.inputStyle))), A.onfocus = () => {
            l.showInput(r);
          }, A.onblur = () => {
            A === Y.doc.activeElement && p(r), l.hideInput(r), l.setInputValue(r), A.blur();
          };
          let G = !1;
          return A.onchange = () => {
            G || (p(r), l.hideInput(r), A.blur());
          }, A.onkeypress = (R) => {
            R.keyCode === 13 && p(r);
          }, A.onkeydown = (R) => {
            G = !0, (R.key === "ArrowUp" || R.key === "ArrowDown" || R.key === "Tab") && p(r);
          }, A.onkeyup = () => {
            G = !1;
          }, { dateBox: v, input: A, label: m };
        }
        getPosition() {
          let r = this.chart, o = r.options.rangeSelector, i = o.verticalAlign === "top" ? r.plotTop - r.axisOffset[0] : 0;
          return { buttonTop: i + o.buttonPosition.y, inputTop: i + o.inputPosition.y - 10 };
        }
        getYTDExtremes(r, o, i) {
          let s = this.chart.time, l = new s.Date(r), t = s.get("FullYear", l), e = Math.max(o, i ? s.Date.UTC(t, 0, 1) : +new s.Date(t, 0, 1)), a = l.getTime();
          return { max: Math.min(r || a, a), min: e };
        }
        createElements() {
          var a;
          let r = this.chart, o = r.renderer, i = r.container, s = r.options, l = s.rangeSelector, t = l.inputEnabled, e = y((a = s.chart.style) == null ? void 0 : a.zIndex, 0) + 1;
          if (l.enabled !== !1 && (this.group = o.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = _("div", void 0, { position: "relative", height: 0, zIndex: e }), this.buttonOptions.length && this.renderButtons(), i.parentNode && i.parentNode.insertBefore(this.div, i), t)) {
            this.inputGroup = o.g("input-group").add(this.group);
            let n = this.drawInput("min");
            this.minDateBox = n.dateBox, this.minLabel = n.label, this.minInput = n.input;
            let h = this.drawInput("max");
            this.maxDateBox = h.dateBox, this.maxLabel = h.label, this.maxInput = h.input;
          }
        }
        render(r, o) {
          let i = this.chart, s = i.options.rangeSelector, l = s.inputEnabled;
          if (s.enabled !== !1) {
            if (l) {
              this.setInputValue("min", r), this.setInputValue("max", o);
              let t = i.scroller && i.scroller.getUnionExtremes() || i.xAxis[0] || {};
              if (M(t.dataMin) && M(t.dataMax)) {
                let e = i.xAxis[0].minRange || 0;
                this.setInputExtremes("min", t.dataMin, Math.min(t.dataMax, this.getInputValue("max")) - e), this.setInputExtremes("max", Math.max(t.dataMin, this.getInputValue("min")) + e, t.dataMax);
              }
              if (this.inputGroup) {
                let e = 0;
                [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((a) => {
                  if (a) {
                    let { width: n } = a.getBBox();
                    n && (a.attr({ x: e }), e += n + s.inputSpacing);
                  }
                });
              }
            }
            this.alignElements(), this.updateButtonStates();
          }
        }
        renderButtons() {
          var m;
          let { buttons: r, chart: o, options: i } = this, s = I.lang, l = o.renderer, t = c(i.buttonTheme), e = t && t.states, a = t.width || 28;
          delete t.width, delete t.states, this.buttonGroup = l.g("range-selector-buttons").add(this.group);
          let n = this.dropdown = _("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), h = (m = o.userOptions.rangeSelector) == null ? void 0 : m.buttonTheme;
          this.dropdownLabel = l.button("", 0, 0, () => {
          }, c(t, { "stroke-width": y(t["stroke-width"], 0), width: "auto", paddingLeft: y(i.buttonTheme.paddingLeft, h == null ? void 0 : h.padding, 8), paddingRight: y(i.buttonTheme.paddingRight, h == null ? void 0 : h.padding, 8) }), e && e.hover, e && e.select, e && e.disabled).hide().add(this.group), z(n, "touchstart", () => {
            n.style.fontSize = "16px";
          });
          let p = Y.isMS ? "mouseover" : "mouseenter", f = Y.isMS ? "mouseout" : "mouseleave";
          z(n, p, () => {
            k(this.dropdownLabel.element, p);
          }), z(n, f, () => {
            k(this.dropdownLabel.element, f);
          }), z(n, "change", () => {
            k(this.buttons[n.selectedIndex - 1].element, "click");
          }), this.zoomText = l.label(s.rangeSelectorZoom || "", 0).attr({ padding: i.buttonTheme.padding, height: i.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(i.labelStyle), t["stroke-width"] = y(t["stroke-width"], 0)), _("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, n), this.buttonOptions.forEach((v, A) => {
            _("option", { textContent: v.title || v.text }, void 0, n), r[A] = l.button(v.text, 0, 0, (G) => {
              let R, P = v.events && v.events.click;
              P && (R = P.call(v, G)), R !== !1 && this.clickButton(A), this.isActive = !0;
            }, t, e && e.hover, e && e.select, e && e.disabled).attr({ "text-align": "center", width: a }).add(this.buttonGroup), v.title && r[A].attr("title", v.title);
          });
        }
        alignElements() {
          var A;
          let { buttonGroup: r, buttons: o, chart: i, group: s, inputGroup: l, options: t, zoomText: e } = this, a = i.options, n = a.exporting && a.exporting.enabled !== !1 && a.navigation && a.navigation.buttonOptions, { buttonPosition: h, inputPosition: p, verticalAlign: f } = t, m = (G, R) => n && this.titleCollision(i) && f === "top" && R.align === "right" && R.y - G.getBBox().height - 12 < (n.y || 0) + (n.height || 0) + i.spacing[0] ? -40 : 0, v = i.plotLeft;
          if (s && h && p) {
            let G = h.x - i.spacing[3];
            if (r) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                let X = 0;
                e && (X += e.getBBox().width + 5), o.forEach(($, Q) => {
                  X += $.width || 0, Q !== o.length - 1 && (X += t.buttonSpacing);
                }), this.initialButtonGroupWidth = X;
              }
              v -= i.spacing[3];
              let K = m(r, h);
              this.alignButtonGroup(K), (A = this.buttonGroup) != null && A.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), s.placed = r.placed = i.hasLoaded;
            }
            let R = 0;
            l && (R = m(l, p), p.align === "left" ? G = v : p.align === "right" && (G = -Math.max(i.axisOffset[1], -R)), l.align({ y: p.y, width: l.getBBox().width, align: p.align, x: p.x + G - 2 }, !0, i.spacingBox), l.placed = i.hasLoaded), this.handleCollision(R), s.align({ verticalAlign: f }, !0, i.spacingBox);
            let P = s.alignAttr.translateY, j = s.getBBox().height + 20, T = 0;
            if (f === "bottom") {
              let K = i.legend && i.legend.options;
              T = P - (j = j + (K && K.verticalAlign === "bottom" && K.enabled && !K.floating ? i.legend.legendHeight + y(K.margin, 10) : 0) - 20) - (t.floating ? 0 : t.y) - (i.titleOffset ? i.titleOffset[2] : 0) - 10;
            }
            f === "top" ? (t.floating && (T = 0), i.titleOffset && i.titleOffset[0] && (T = i.titleOffset[0]), T += i.margin[0] - i.spacing[0] || 0) : f === "middle" && (p.y === h.y ? T = P : (p.y || h.y) && (p.y < 0 || h.y < 0 ? T -= Math.min(p.y, h.y) : T = P - j)), s.translate(t.x, t.y + Math.floor(T));
            let { minInput: W, maxInput: L, dropdown: F } = this;
            t.inputEnabled && W && L && (W.style.marginTop = s.translateY + "px", L.style.marginTop = s.translateY + "px"), F && (F.style.marginTop = s.translateY + "px");
          }
        }
        alignButtonGroup(r, o) {
          let { chart: i, options: s, buttonGroup: l } = this, { buttonPosition: t } = s, e = i.plotLeft - i.spacing[3], a = t.x - i.spacing[3];
          t.align === "right" ? a += r - e : t.align === "center" && (a -= e / 2), l && l.align({ y: t.y, width: y(o, this.initialButtonGroupWidth), align: t.align, x: a }, !0, i.spacingBox);
        }
        positionButtons() {
          let { buttons: r, chart: o, options: i, zoomText: s } = this, l = o.hasLoaded ? "animate" : "attr", { buttonPosition: t } = i, e = o.plotLeft, a = e;
          s && s.visibility !== "hidden" && (s[l]({ x: y(e + t.x, e) }), a += t.x + s.getBBox().width + 5);
          for (let n = 0, h = this.buttonOptions.length; n < h; ++n) r[n].visibility !== "hidden" ? (r[n][l]({ x: a }), a += (r[n].width || 0) + i.buttonSpacing) : r[n][l]({ x: e });
        }
        handleCollision(r) {
          let { chart: o, buttonGroup: i, inputGroup: s } = this, { buttonPosition: l, dropdown: t, inputPosition: e } = this.options, a = () => {
            let p = 0;
            return this.buttons.forEach((f) => {
              let m = f.getBBox();
              m.width > p && (p = m.width);
            }), p;
          }, n = (p) => {
            if (s != null && s.alignOptions && i) {
              let f = s.alignAttr.translateX + s.alignOptions.x - r + s.getBBox().x + 2, m = s.alignOptions.width || 0, v = i.alignAttr.translateX + i.getBBox().x;
              return v + p > f && f + m > v && l.y < e.y + s.getBBox().height;
            }
            return !1;
          }, h = () => {
            s && i && s.attr({ translateX: s.alignAttr.translateX + (o.axisOffset[1] >= -r ? 0 : -r), translateY: s.alignAttr.translateY + i.getBBox().height + 10 });
          };
          if (i) {
            if (t === "always") {
              this.collapseButtons(), n(a()) && h();
              return;
            }
            t === "never" && this.expandButtons();
          }
          s && i ? e.align === l.align || n(this.initialButtonGroupWidth + 20) ? t === "responsive" ? (this.collapseButtons(), n(a()) && h()) : h() : t === "responsive" && this.expandButtons() : i && t === "responsive" && (this.initialButtonGroupWidth > o.plotWidth ? this.collapseButtons() : this.expandButtons());
        }
        collapseButtons() {
          let { buttons: r, zoomText: o } = this;
          this.isCollapsed !== !0 && (this.isCollapsed = !0, o.hide(), r.forEach((i) => void i.hide()), this.showDropdown());
        }
        expandButtons() {
          let { buttons: r, zoomText: o } = this;
          this.isCollapsed !== !1 && (this.isCollapsed = !1, this.hideDropdown(), o.show(), r.forEach((i) => void i.show()), this.positionButtons());
        }
        showDropdown() {
          let { buttonGroup: r, chart: o, dropdownLabel: i, dropdown: s } = this;
          if (r && s) {
            let { translateX: l = 0, translateY: t = 0 } = r, e = o.plotLeft + l;
            i.attr({ x: e, y: t }).show(), C(s, { left: e + "px", top: t + "px", visibility: "inherit" }), this.hasVisibleDropdown = !0;
          }
        }
        hideDropdown() {
          let { dropdown: r } = this;
          r && (this.dropdownLabel.hide(), C(r, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
        }
        getHeight() {
          let r = this.options, o = this.group, i = r.inputPosition, s = r.buttonPosition, l = r.y, t = s.y, e = i.y, a = 0;
          if (r.height) return r.height;
          this.alignElements(), a = o ? o.getBBox(!0).height + 13 + l : 0;
          let n = Math.min(e, t);
          return (e < 0 && t < 0 || e > 0 && t > 0) && (a += Math.abs(n)), a;
        }
        titleCollision(r) {
          return !(r.options.title.text || r.options.subtitle.text);
        }
        update(r, o = !0) {
          let i = this.chart;
          c(!0, i.options.rangeSelector, r), this.destroy(), this.init(i), o && this.render();
        }
        destroy() {
          let r = this, o = r.minInput, i = r.maxInput;
          r.eventsToUnbind && (r.eventsToUnbind.forEach((s) => s()), r.eventsToUnbind = void 0), S(r.buttons), o && (o.onfocus = o.onblur = o.onchange = null), i && (i.onfocus = i.onblur = i.onchange = null), w(r, function(s, l) {
            s && l !== "chart" && (s instanceof Z ? s.destroy() : s instanceof window.HTMLElement && U(s)), s !== u.prototype[l] && (r[l] = null);
          }, this);
        }
      }
      return b(u.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), u;
    }), J(x, "Core/Chart/StockChart.js", [x["Core/Chart/Chart.js"], x["Core/Templating.js"], x["Core/Defaults.js"], x["Stock/Navigator/NavigatorDefaults.js"], x["Stock/RangeSelector/RangeSelectorDefaults.js"], x["Stock/Scrollbar/ScrollbarDefaults.js"], x["Stock/Utilities/StockUtilities.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z, q, N, I) {
      let { format: z } = H, { getOptions: _ } = Y, { setFixedRange: C } = N, { addEvent: M, clamp: S, crisp: U, defined: b, extend: k, find: O, isNumber: c, isString: w, merge: g, pick: y, splat: B } = I;
      function d(r, o, i) {
        var s, l, t, e;
        return r === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0 } : r === "yAxis" ? { labels: { y: -2 }, opposite: (l = (s = i.opposite) != null ? s : o.opposite) != null ? l : !0, showLastLabel: !!(o.categories || o.type === "category"), title: { text: ((t = i.title) == null ? void 0 : t.text) !== "Values" ? (e = i.title) == null ? void 0 : e.text : null } } : {};
      }
      function u(r, o) {
        if (r === "xAxis") {
          let i = y(o.navigator && o.navigator.enabled, V.enabled, !0), s = { type: "datetime", categories: void 0 };
          return i && (s.startOnTick = !1, s.endOnTick = !1), s;
        }
        return {};
      }
      class E extends D {
        init(o, i) {
          let s = _(), l = o.xAxis, t = o.yAxis, e = y(o.navigator && o.navigator.enabled, V.enabled, !0);
          o.xAxis = o.yAxis = void 0;
          let a = g({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: e }, scrollbar: { enabled: y(q.enabled, !0) }, rangeSelector: { enabled: y(Z.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: y(s.tooltip && s.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, o, { isStock: !0 });
          o.xAxis = l, o.yAxis = t, a.xAxis = B(o.xAxis || {}).map((n) => g(d("xAxis", n, s.xAxis), n, u("xAxis", o))), a.yAxis = B(o.yAxis || {}).map((n) => g(d("yAxis", n, s.yAxis), n)), super.init(a, i);
        }
        createAxis(o, i) {
          return i.axis = g(d(o, i.axis, _()[o]), i.axis, u(o, this.userOptions)), super.createAxis(o, i);
        }
      }
      return M(D, "update", function(r) {
        let o = r.options;
        "scrollbar" in o && this.navigator && (g(!0, this.options.scrollbar, o.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete o.scrollbar);
      }), function(r) {
        function o(h) {
          if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !c(this.min) || !c(this.max)) return;
          let p = this.chart, f = this.logarithmic, m = this.crosshair.label, v = this.horiz, A = this.opposite, G = this.left, R = this.top, P = this.width, j = this.options.tickPosition === "inside", T = this.crosshair.snap !== !1, W = h.e || this.cross && this.cross.e, L = h.point, F = this.crossLabel, K, X, $ = m.format, Q = "", tt, et = 0, ot = this.min, it = this.max;
          f && (ot = f.lin2log(this.min), it = f.lin2log(this.max));
          let rt = v ? "center" : A ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
          F || (F = this.crossLabel = p.renderer.label("", 0, void 0, m.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (L && L.series ? L.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: m.align || rt, padding: y(m.padding, 8), r: y(m.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), p.styledMode || F.attr({ fill: m.backgroundColor || L && L.series && L.series.color || "#666666", stroke: m.borderColor || "", "stroke-width": m.borderWidth || 0 }).css(k({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, m.style || {}))), v ? (K = T ? (L.plotX || 0) + G : W.chartX, X = R + (A ? 0 : this.height)) : (K = G + this.offset + (A ? P : 0), X = T ? (L.plotY || 0) + R : W.chartY), $ || m.formatter || (this.dateTime && (Q = "%b %d, %Y"), $ = "{value" + (Q ? ":" + Q : "") + "}");
          let lt = T ? this.isXAxis ? L.x : L.y : this.toValue(v ? W.chartX : W.chartY), pt = L && L.series ? L.series.isPointInside(L) : c(lt) && lt > ot && lt < it, ht = "";
          $ ? ht = z($, { value: lt }, p) : m.formatter && c(lt) && (ht = m.formatter.call(this, lt)), F.attr({ text: ht, x: K, y: X, visibility: pt ? "inherit" : "hidden" });
          let at = F.getBBox();
          !c(F.x) || v || A || (K = F.x - at.width / 2), c(F.y) && (v ? (j && !A || !j && A) && (X = F.y - at.height) : X = F.y - at.height / 2), tt = v ? { left: G, right: G + this.width } : { left: this.labelAlign === "left" ? G : 0, right: this.labelAlign === "right" ? G + this.width : p.chartWidth };
          let nt = F.translateX || 0;
          nt < tt.left && (et = tt.left - nt), nt + at.width >= tt.right && (et = -(nt + at.width - tt.right)), F.attr({ x: K + et, y: X, anchorX: v ? K : this.opposite ? 0 : p.chartWidth, anchorY: v ? this.opposite ? p.chartHeight : 0 : X + at.height / 2 });
        }
        function i() {
          this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        }
        function s(h) {
          let p = this.chart, f = this.options, m = p._labelPanes = p._labelPanes || {}, v = f.labels;
          if (p.options.isStock && this.coll === "yAxis") {
            let A = f.top + "," + f.height;
            !m[A] && v.enabled && (v.distance === 15 && this.side === 1 && (v.distance = 0), v.align === void 0 && (v.align = "right"), m[A] = this, h.align = "right", h.preventDefault());
          }
        }
        function l() {
          let h = this.chart, p = this.options && this.options.top + "," + this.options.height;
          p && h._labelPanes && h._labelPanes[p] === this && delete h._labelPanes[p];
        }
        function t(h) {
          let p = this, f = p.isLinked && !p.series && p.linkedParent ? p.linkedParent.series : p.series, m = p.chart, v = m.renderer, A = p.left, G = p.top, R = [], P = h.translatedValue, j = h.value, T = h.force, W, L, F, K, X = [], $, Q;
          if (m.options.isStock && h.acrossPanes !== !1 && p.coll === "xAxis" || p.coll === "yAxis") {
            for (let tt of (h.preventDefault(), X = ((et) => {
              let ot = et === "xAxis" ? "yAxis" : "xAxis", it = p.options[ot];
              return c(it) ? [m[ot][it]] : w(it) ? [m.get(it)] : f.map((rt) => rt[ot]);
            })(p.coll), p.isXAxis ? m.yAxis : m.xAxis)) if (!tt.options.isInternal) {
              let et = tt.isXAxis ? "yAxis" : "xAxis";
              p === (b(tt.options[et]) ? m[et][tt.options[et]] : m[et][0]) && X.push(tt);
            }
            for (let tt of ($ = X.length ? [] : [p.isXAxis ? m.yAxis[0] : m.xAxis[0]], X)) $.indexOf(tt) !== -1 || O($, (et) => et.pos === tt.pos && et.len === tt.len) || $.push(tt);
            if (c(Q = y(P, p.translate(j || 0, void 0, void 0, h.old))))
              if (p.horiz) for (let tt of $) {
                let et;
                K = (L = tt.pos) + tt.len, W = F = Math.round(Q + p.transB), T !== "pass" && (W < A || W > A + p.width) && (T ? W = F = S(W, A, A + p.width) : et = !0), et || R.push(["M", W, L], ["L", F, K]);
              }
              else for (let tt of $) {
                let et;
                F = (W = tt.pos) + tt.len, L = K = Math.round(G + p.height - Q), T !== "pass" && (L < G || L > G + p.height) && (T ? L = K = S(L, G, G + p.height) : et = !0), et || R.push(["M", W, L], ["L", F, K]);
              }
            h.path = R.length > 0 ? v.crispPolyLine(R, h.lineWidth || 1) : void 0;
          }
        }
        function e(h) {
          if (this.chart.options.isStock) {
            let p;
            this.is("column") || this.is("columnrange") ? p = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (p = { marker: { enabled: !1, radius: 2 } }), p && (h.plotOptions[this.type] = g(h.plotOptions[this.type], p));
          }
        }
        function a() {
          let h = this.chart, p = this.options.dataGrouping;
          return this.allowDG !== !1 && p && y(p.enabled, h.options.isStock);
        }
        function n(h, p) {
          for (let f = 0; f < h.length; f += 2) {
            let m = h[f], v = h[f + 1];
            b(m[1]) && m[1] === v[1] && (m[1] = v[1] = U(m[1], p)), b(m[2]) && m[2] === v[2] && (m[2] = v[2] = U(m[2], p));
          }
          return h;
        }
        r.compose = function(h, p, f, m) {
          let v = f.prototype;
          v.forceCropping || (M(p, "afterDrawCrosshair", o), M(p, "afterHideCrosshair", i), M(p, "autoLabelAlign", s), M(p, "destroy", l), M(p, "getPlotLinePath", t), h.prototype.setFixedRange = C, v.forceCropping = a, M(f, "setOptions", e), m.prototype.crispPolyLine = n);
        }, r.stockChart = function(h, p, f) {
          return new r(h, p, f);
        };
      }(E || (E = {})), E;
    }), J(x, "Series/HLC/HLCPoint.js", [x["Core/Series/SeriesRegistry.js"]], function(D) {
      let { column: { prototype: { pointClass: H } } } = D.seriesTypes;
      return class extends H {
      };
    }), J(x, "Series/HLC/HLCSeriesDefaults.js", [], function() {
      return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
    }), J(x, "Series/HLC/HLCSeries.js", [x["Series/HLC/HLCPoint.js"], x["Series/HLC/HLCSeriesDefaults.js"], x["Core/Series/SeriesRegistry.js"], x["Core/Utilities.js"]], function(D, H, Y, V) {
      let { column: Z } = Y.seriesTypes, { crisp: q, extend: N, merge: I } = V;
      class z extends Z {
        extendStem(C, M, S) {
          let U = C[0], b = C[1];
          typeof U[2] == "number" && (U[2] = Math.max(S + M, U[2])), typeof b[2] == "number" && (b[2] = Math.min(S - M, b[2]));
        }
        getPointPath(C, M) {
          let S = M.strokeWidth(), U = C.series, b = q(C.plotX || 0, S), k = Math.round(C.shapeArgs.width / 2), O = [["M", b, Math.round(C.yBottom)], ["L", b, Math.round(C.plotHigh)]];
          if (C.close !== null) {
            let c = q(C.plotClose, S);
            O.push(["M", b, c], ["L", b + k, c]), U.extendStem(O, S / 2, c);
          }
          return O;
        }
        drawSinglePoint(C) {
          let M = C.series, S = M.chart, U, b = C.graphic;
          C.plotY !== void 0 && (b || (C.graphic = b = S.renderer.path().add(M.group)), S.styledMode || b.attr(M.pointAttribs(C, C.selected && "select")), U = M.getPointPath(C, b), b[b ? "animate" : "attr"]({ d: U }).addClass(C.getClassName(), !0));
        }
        drawPoints() {
          this.points.forEach(this.drawSinglePoint);
        }
        init() {
          super.init.apply(this, arguments), this.options.stacking = void 0;
        }
        pointAttribs(C, M) {
          let S = super.pointAttribs.call(this, C, M);
          return delete S.fill, S;
        }
        toYData(C) {
          return [C.high, C.low, C.close];
        }
        translate() {
          let C = this, M = C.yAxis, S = this.pointArrayMap && this.pointArrayMap.slice() || [], U = S.map((b) => `plot${b.charAt(0).toUpperCase() + b.slice(1)}`);
          U.push("yBottom"), S.push("low"), super.translate.apply(C), C.points.forEach(function(b) {
            S.forEach(function(k, O) {
              let c = b[k];
              c !== null && (C.dataModify && (c = C.dataModify.modifyValue(c)), b[U[O]] = M.toPixels(c, !0));
            }), b.tooltipPos[1] = b.plotHigh + M.pos - C.chart.plotTop;
          });
        }
      }
      return z.defaultOptions = I(Z.defaultOptions, H), N(z.prototype, { pointClass: D, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), Y.registerSeriesType("hlc", z), z;
    }), J(x, "Series/OHLC/OHLCPoint.js", [x["Core/Series/SeriesRegistry.js"]], function(D) {
      let { seriesTypes: { hlc: H } } = D;
      class Y extends H.prototype.pointClass {
        getClassName() {
          return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
        resolveUpColor() {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }
        resolveColor() {
          super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
        }
        getZone() {
          let Z = super.getZone();
          return this.resolveUpColor(), Z;
        }
        applyOptions() {
          return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }
      }
      return Y;
    }), J(x, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
      return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
    }), J(x, "Series/OHLC/OHLCSeries.js", [x["Core/Globals.js"], x["Series/OHLC/OHLCPoint.js"], x["Series/OHLC/OHLCSeriesDefaults.js"], x["Core/Series/SeriesRegistry.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z) {
      let { composed: q } = D, { hlc: N } = V.seriesTypes, { addEvent: I, crisp: z, extend: _, merge: C, pushUnique: M } = Z;
      function S(k) {
        let O = k.options, c = O.dataGrouping;
        c && O.useOhlcData && O.id !== "highcharts-navigator-series" && (c.approximation = "ohlc");
      }
      function U(k) {
        let O = k.options;
        O.useOhlcData && O.id !== "highcharts-navigator-series" && _(this, { pointValKey: b.prototype.pointValKey, pointArrayMap: b.prototype.pointArrayMap, toYData: b.prototype.toYData });
      }
      class b extends N {
        static compose(O, ...c) {
          M(q, "OHLCSeries") && (I(O, "afterSetOptions", S), I(O, "init", U));
        }
        getPointPath(O, c) {
          let w = super.getPointPath(O, c), g = c.strokeWidth(), y = z(O.plotX || 0, g), B = Math.round(O.shapeArgs.width / 2);
          if (O.open !== null) {
            let d = z(O.plotOpen, g);
            w.push(["M", y, d], ["L", y - B, d]), super.extendStem(w, g / 2, d);
          }
          return w;
        }
        pointAttribs(O, c) {
          let w = super.pointAttribs.call(this, O, c), g = this.options;
          return delete w.fill, !O.options.color && g.upColor && O.open < O.close && (w.stroke = g.upColor), w;
        }
        toYData(O) {
          return [O.open, O.high, O.low, O.close];
        }
      }
      return b.defaultOptions = C(N.defaultOptions, Y), _(b.prototype, { pointClass: H, pointArrayMap: ["open", "high", "low", "close"] }), V.registerSeriesType("ohlc", b), b;
    }), J(x, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
      return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
    }), J(x, "Series/Candlestick/CandlestickSeries.js", [x["Series/Candlestick/CandlestickSeriesDefaults.js"], x["Core/Series/SeriesRegistry.js"], x["Core/Utilities.js"]], function(D, H, Y) {
      let { column: V, ohlc: Z } = H.seriesTypes, { crisp: q, merge: N } = Y;
      class I extends Z {
        pointAttribs(_, C) {
          let M = V.prototype.pointAttribs.call(this, _, C), S = this.options, U = _.open < _.close, b = S.lineColor || this.color, k = _.color || this.color;
          if (M["stroke-width"] = S.lineWidth, M.fill = _.options.color || U && S.upColor || k, M.stroke = _.options.lineColor || U && S.upLineColor || b, C) {
            let O = S.states[C];
            M.fill = O.color || M.fill, M.stroke = O.lineColor || M.stroke, M["stroke-width"] = O.lineWidth || M["stroke-width"];
          }
          return M;
        }
        drawPoints() {
          let _ = this.points, C = this.chart, M = this.yAxis.reversed;
          for (let S of _) {
            let U = S.graphic, b, k, O, c, w, g, y, B, d, u = !U;
            if (S.plotY !== void 0) {
              U || (S.graphic = U = C.renderer.path().add(this.group)), this.chart.styledMode || U.attr(this.pointAttribs(S, S.selected && "select")).shadow(this.options.shadow);
              let E = U.strokeWidth();
              y = q(S.plotX || 0, E), O = Math.min(b = S.plotOpen, k = S.plotClose), c = Math.max(b, k), d = Math.round(S.shapeArgs.width / 2), w = M ? c !== S.yBottom : Math.round(O) !== Math.round(S.plotHigh || 0), g = M ? Math.round(O) !== Math.round(S.plotHigh || 0) : c !== S.yBottom, O = q(O, E), c = q(c, E), (B = []).push(["M", y - d, c], ["L", y - d, O], ["L", y + d, O], ["L", y + d, c], ["Z"], ["M", y, O], ["L", y, w ? Math.round(M ? S.yBottom : S.plotHigh) : O], ["M", y, c], ["L", y, g ? Math.round(M ? S.plotHigh : S.yBottom) : c]), U[u ? "attr" : "animate"]({ d: B }).addClass(S.getClassName(), !0);
            }
          }
        }
      }
      return I.defaultOptions = N(Z.defaultOptions, { tooltip: Z.defaultOptions.tooltip }, D), H.registerSeriesType("candlestick", I), I;
    }), J(x, "Series/Flags/FlagsPoint.js", [x["Core/Series/SeriesRegistry.js"], x["Core/Utilities.js"]], function(D, H) {
      let { column: { prototype: { pointClass: Y } } } = D.seriesTypes, { isNumber: V } = H;
      return class extends Y {
        constructor() {
          super(...arguments), this.ttBelow = !1;
        }
        isValid() {
          return V(this.y) || this.y === void 0;
        }
        hasNewShapeType() {
          let Z = this.options.shape || this.series.options.shape;
          return this.graphic && Z && Z !== this.graphic.symbolKey;
        }
      };
    }), J(x, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
      return { borderRadius: 0, pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
    }), J(x, "Series/Flags/FlagsSymbols.js", [x["Core/Renderer/RendererRegistry.js"]], function(D) {
      var H;
      return function(Y) {
        let V = [];
        function Z(N, I, z, _, C) {
          let M = C && C.anchorX || N, S = C && C.anchorY || I, U = this.circle(M - 1, S - 1, 2, 2);
          return U.push(["M", M, S], ["L", N, I + _], ["L", N, I], ["L", N + z, I], ["L", N + z, I + _], ["L", N, I + _], ["Z"]), U;
        }
        function q(N, I) {
          N[I + "pin"] = function(z, _, C, M, S) {
            let U, b = S && S.anchorX, k = S && S.anchorY;
            if (I === "circle" && M > C && (z -= Math.round((M - C) / 2), C = M), U = N[I](z, _, C, M, S), b && k) {
              let O = b;
              if (I === "circle") O = z + C / 2;
              else {
                let w = U[0], g = U[1];
                w[0] === "M" && g[0] === "L" && (O = (w[1] + g[1]) / 2);
              }
              let c = _ > k ? _ : _ + M;
              U.push(["M", O, c], ["L", b, k]), U = U.concat(N.circle(b - 1, k - 1, 2, 2));
            }
            return U;
          };
        }
        Y.compose = function(N) {
          if (V.indexOf(N) === -1) {
            V.push(N);
            let z = N.prototype.symbols;
            z.flag = Z, q(z, "circle"), q(z, "square");
          }
          let I = D.getRendererType();
          V.indexOf(I) && V.push(I);
        };
      }(H || (H = {})), H;
    }), J(x, "Series/OnSeriesComposition.js", [x["Series/Column/ColumnSeries.js"], x["Core/Globals.js"], x["Core/Series/Series.js"], x["Core/Utilities.js"]], function(D, H, Y, V) {
      var Z;
      let { composed: q } = H, { prototype: N } = D, { prototype: I } = Y, { defined: z, pushUnique: _, stableSort: C } = V;
      return function(M) {
        function S(b) {
          return I.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, b);
        }
        function U() {
          var f, m;
          N.translate.apply(this);
          let b = this, k = b.options, O = b.chart, c = b.points, w = k.onSeries, g = w && O.get(w), y = g && g.options.step, B = g && g.points, d = O.inverted, u = b.xAxis, E = b.yAxis, r = c.length - 1, o, i, s = k.onKey || "y", l = B && B.length, t = 0, e, a, n, h, p;
          if (g && g.visible && l) {
            for (t = (g.pointXOffset || 0) + (g.barW || 0) / 2, h = g.currentDataGrouping, a = B[l - 1].x + (h ? h.totalRange : 0), C(c, (v, A) => v.x - A.x), s = "plot" + s[0].toUpperCase() + s.substr(1); l-- && c[r]; ) if (e = B[l], (o = c[r]).y = e.y, e.x <= o.x && e[s] !== void 0) {
              if (o.x <= a && (o.plotY = e[s], e.x < o.x && !y && (n = B[l + 1]) && n[s] !== void 0))
                if (z(o.plotX) && g.is("spline")) {
                  let v = [e.plotX || 0, e.plotY || 0], A = [n.plotX || 0, n.plotY || 0], G = ((f = e.controlPoints) == null ? void 0 : f.high) || v, R = ((m = n.controlPoints) == null ? void 0 : m.low) || A, P = (L, F) => Math.pow(1 - L, 3) * v[F] + 3 * (1 - L) * (1 - L) * L * G[F] + 3 * (1 - L) * L * L * R[F] + L * L * L * A[F], j = 0, T = 1, W;
                  for (let L = 0; L < 100; L++) {
                    let F = (j + T) / 2, K = P(F, 0);
                    if (K === null) break;
                    if (0.25 > Math.abs(K - o.plotX)) {
                      W = F;
                      break;
                    }
                    K < o.plotX ? j = F : T = F;
                  }
                  z(W) && (o.plotY = P(W, 1), o.y = E.toValue(o.plotY, !0));
                } else p = (o.x - e.x) / (n.x - e.x), o.plotY += p * (n[s] - e[s]), o.y += p * (n.y - e.y);
              if (r--, l++, r < 0) break;
            }
          }
          c.forEach((v, A) => {
            let G;
            v.plotX += t, (v.plotY === void 0 || d) && (v.plotX >= 0 && v.plotX <= u.len ? d ? (v.plotY = u.translate(v.x, 0, 1, 0, 1), v.plotX = z(v.y) ? E.translate(v.y, 0, 0, 0, 1) : 0) : v.plotY = (u.opposite ? 0 : b.yAxis.len) + u.offset : v.shapeArgs = {}), (i = c[A - 1]) && i.plotX === v.plotX && (i.stackIndex === void 0 && (i.stackIndex = 0), G = i.stackIndex + 1), v.stackIndex = G;
          }), this.onSeries = g;
        }
        M.compose = function(b) {
          if (_(q, "OnSeries")) {
            let k = b.prototype;
            k.getPlotBox = S, k.translate = U;
          }
          return b;
        }, M.getPlotBox = S, M.translate = U;
      }(Z || (Z = {})), Z;
    }), J(x, "Series/Flags/FlagsSeries.js", [x["Series/Flags/FlagsPoint.js"], x["Series/Flags/FlagsSeriesDefaults.js"], x["Series/Flags/FlagsSymbols.js"], x["Core/Globals.js"], x["Series/OnSeriesComposition.js"], x["Core/Renderer/RendererUtilities.js"], x["Core/Series/SeriesRegistry.js"], x["Core/Renderer/SVG/SVGElement.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z, q, N, I, z) {
      let { noop: _ } = V, { distribute: C } = q, { series: M, seriesTypes: { column: S } } = N, { addEvent: U, defined: b, extend: k, isNumber: O, merge: c, objectEach: w, wrap: g } = z;
      class y extends S {
        animate(d) {
          d && this.setClip();
        }
        drawPoints() {
          var j, T;
          let d, u, E, r, o, i, s, l, t, e, a, n = this.points, h = this.chart, p = h.renderer, f = h.inverted, m = this.options, v = m.y, A = this.yAxis, G = {}, R = [], P = O(m.borderRadius) ? m.borderRadius : 0;
          for (r = n.length; r--; ) o = n[r], e = (f ? o.plotY : o.plotX) > this.xAxis.len, d = o.plotX, s = o.stackIndex, E = o.options.shape || m.shape, (u = o.plotY) !== void 0 && (u = o.plotY + v - (s !== void 0 && s * m.stackDistance)), o.anchorX = s ? void 0 : o.plotX, l = s ? void 0 : o.plotY, a = E !== "flag", i = o.graphic, u !== void 0 && d >= 0 && !e ? (i && o.hasNewShapeType() && (i = i.destroy()), i || (i = o.graphic = p.label("", 0, void 0, E, void 0, void 0, m.useHTML).addClass("highcharts-point").add(this.markerGroup), o.graphic.div && (o.graphic.div.point = o), i.isNew = !0), i.attr({ align: a ? "center" : "left", width: m.width, height: m.height, "text-align": m.textAlign, r: P }), h.styledMode || i.attr(this.pointAttribs(o)).css(c(m.style, o.style)).shadow(m.shadow), d > 0 && (d -= i.strokeWidth() % 2), t = { y: u, anchorY: l }, m.allowOverlapX && (t.x = d, t.anchorX = o.anchorX), i.attr({ text: (T = (j = o.options.title) != null ? j : m.title) != null ? T : "A" })[i.isNew ? "attr" : "animate"](t), m.allowOverlapX || (G[o.plotX] ? G[o.plotX].size = Math.max(G[o.plotX].size, i.width || 0) : G[o.plotX] = { align: a ? 0.5 : 0, size: i.width || 0, target: d, anchorX: d }), o.tooltipPos = [d, u + A.pos - h.plotTop]) : i && (o.graphic = i.destroy());
          if (!m.allowOverlapX) {
            let W = 100;
            for (let L of (w(G, function(F) {
              F.plotX = F.anchorX, R.push(F), W = Math.max(F.size, W);
            }), C(R, f ? A.len : this.xAxis.len, W), n)) {
              let F = L.plotX, K = L.graphic, X = K && G[F];
              X && K && (b(X.pos) ? K[K.isNew ? "attr" : "animate"]({ x: X.pos + (X.align || 0) * X.size, anchorX: L.anchorX }).show().isNew = !1 : K.hide().isNew = !0);
            }
          }
          m.useHTML && this.markerGroup && g(this.markerGroup, "on", function(W) {
            return I.prototype.on.apply(W.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }
        drawTracker() {
          let d = this.points;
          for (let u of (super.drawTracker(), d)) {
            let E = u.graphic;
            E && (u.unbindMouseOver && u.unbindMouseOver(), u.unbindMouseOver = U(E.element, "mouseover", function() {
              for (let r of (u.stackIndex > 0 && !u.raised && (u._y = E.y, E.attr({ y: u._y - 8 }), u.raised = !0), d)) r !== u && r.raised && r.graphic && (r.graphic.attr({ y: r._y }), r.raised = !1);
            }));
          }
        }
        pointAttribs(d, u) {
          let E = this.options, r = d && d.color || this.color, o = E.lineColor, i = d && d.lineWidth, s = d && d.fillColor || E.fillColor;
          return u && (s = E.states[u].fillColor, o = E.states[u].lineColor, i = E.states[u].lineWidth), { fill: s || r, stroke: o || r, "stroke-width": i || E.lineWidth || 0 };
        }
        setClip() {
          M.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }
      }
      return y.compose = Y.compose, y.defaultOptions = c(S.defaultOptions, H), Z.compose(y), k(y.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: D, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: _, init: M.prototype.init }), N.registerSeriesType("flags", y), y;
    }), J(x, "Core/Axis/BrokenAxis.js", [x["Core/Axis/Stacking/StackItem.js"], x["Core/Utilities.js"]], function(D, H) {
      var Y;
      let { addEvent: V, find: Z, fireEvent: q, isArray: N, isNumber: I, pick: z } = H;
      return function(_) {
        function C() {
          this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
        }
        function M() {
          var g;
          (g = this.brokenAxis) != null && g.hasBreaks && (this.options.ordinal = !1);
        }
        function S() {
          let g = this.brokenAxis;
          if (g != null && g.hasBreaks) {
            let y = this.tickPositions, B = this.tickPositions.info, d = [];
            for (let u = 0; u < y.length; u++) g.isInAnyBreak(y[u]) || d.push(y[u]);
            this.tickPositions = d, this.tickPositions.info = B;
          }
        }
        function U() {
          this.brokenAxis || (this.brokenAxis = new w(this));
        }
        function b() {
          var E, r;
          let { isDirty: g, options: { connectNulls: y }, points: B, xAxis: d, yAxis: u } = this;
          if (g) {
            let o = B.length;
            for (; o--; ) {
              let i = B[o], s = !(i.y === null && y === !1) && (((E = d == null ? void 0 : d.brokenAxis) == null ? void 0 : E.isInAnyBreak(i.x, !0)) || ((r = u == null ? void 0 : u.brokenAxis) == null ? void 0 : r.isInAnyBreak(i.y, !0)));
              i.visible = !s && i.options.visible !== !1;
            }
          }
        }
        function k() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, z(this.pointArrayMap, ["y"]));
        }
        function O(g, y) {
          var o;
          let B, d, u, E = this, r = E.points;
          if ((o = g == null ? void 0 : g.brokenAxis) != null && o.hasBreaks) {
            let i = g.brokenAxis;
            y.forEach(function(s) {
              var t, e;
              B = (i == null ? void 0 : i.breakArray) || [], d = g.isXAxis ? g.min : z(E.options.threshold, g.min);
              let l = (e = (t = g == null ? void 0 : g.options) == null ? void 0 : t.breaks) == null ? void 0 : e.filter(function(a) {
                let n = !0;
                for (let h = 0; h < B.length; h++) {
                  let p = B[h];
                  if (p.from === a.from && p.to === a.to) {
                    n = !1;
                    break;
                  }
                }
                return n;
              });
              r.forEach(function(a) {
                u = z(a["stack" + s.toUpperCase()], a[s]), B.forEach(function(n) {
                  if (I(d) && I(u)) {
                    let h = "";
                    d < n.from && u > n.to || d > n.from && u < n.from ? h = "pointBreak" : (d < n.from && u > n.from && u < n.to || d > n.from && u > n.to && u < n.from) && (h = "pointInBreak"), h && q(g, h, { point: a, brk: n });
                  }
                }), l == null || l.forEach(function(n) {
                  q(g, "pointOutsideOfBreak", { point: a, brk: n });
                });
              });
            });
          }
        }
        function c() {
          let g = this.currentDataGrouping, y = g == null ? void 0 : g.gapSize, B = this.points.slice(), d = this.yAxis, u = this.options.gapSize, E = B.length - 1;
          if (u && E > 0) {
            let r, o;
            for (this.options.gapUnit !== "value" && (u *= this.basePointRange), y && y > u && y >= this.basePointRange && (u = y); E--; ) if (o && o.visible !== !1 || (o = B[E + 1]), r = B[E], o.visible !== !1 && r.visible !== !1) {
              if (o.x - r.x > u) {
                let i = (r.x + o.x) / 2;
                B.splice(E + 1, 0, { isNull: !0, x: i }), d.stacking && this.options.stacking && ((d.stacking.stacks[this.stackKey][i] = new D(d, d.options.stackLabels, !1, i, this.stack)).total = 0);
              }
              o = r;
            }
          }
          return this.getGraphPath(B);
        }
        _.compose = function(g, y) {
          if (!g.keepProps.includes("brokenAxis")) {
            g.keepProps.push("brokenAxis"), V(g, "init", U), V(g, "afterInit", C), V(g, "afterSetTickPositions", S), V(g, "afterSetOptions", M);
            let B = y.prototype;
            B.drawBreaks = O, B.gappedPath = c, V(y, "afterGeneratePoints", b), V(y, "afterRender", k);
          }
          return g;
        };
        class w {
          static isInBreak(y, B) {
            let d = y.repeat || 1 / 0, u = y.from, E = y.to - y.from, r = B >= u ? (B - u) % d : d - (u - B) % d;
            return y.inclusive ? r <= E : r < E && r !== 0;
          }
          static lin2Val(y) {
            let B = this.brokenAxis, d = B && B.breakArray;
            if (!d || !I(y)) return y;
            let u = y, E, r;
            for (r = 0; r < d.length && !((E = d[r]).from >= u); r++) (E.to < u || w.isInBreak(E, u)) && (u += E.len);
            return u;
          }
          static val2Lin(y) {
            let B = this.brokenAxis, d = B && B.breakArray;
            if (!d || !I(y)) return y;
            let u = y, E, r;
            for (r = 0; r < d.length; r++) if ((E = d[r]).to <= y) u -= E.len;
            else {
              if (E.from >= y) break;
              if (w.isInBreak(E, y)) {
                u -= y - E.from;
                break;
              }
            }
            return u;
          }
          constructor(y) {
            this.hasBreaks = !1, this.axis = y;
          }
          findBreakAt(y, B) {
            return Z(B, function(d) {
              return d.from < y && y < d.to;
            });
          }
          isInAnyBreak(y, B) {
            let d = this.axis, u = d.options.breaks || [], E = u.length, r, o, i;
            if (E && I(y)) {
              for (; E--; ) w.isInBreak(u[E], y) && (r = !0, o || (o = z(u[E].showPoints, !d.isXAxis)));
              i = r && B ? r && !o : r;
            }
            return i;
          }
          setBreaks(y, B) {
            let d = this, u = d.axis, E = N(y) && !!y.length && !!Object.keys(y[0]).length;
            u.isDirty = d.hasBreaks !== E, d.hasBreaks = E, y !== u.options.breaks && (u.options.breaks = u.userOptions.breaks = y), u.forceRedraw = !0, u.series.forEach(function(r) {
              r.isDirty = !0;
            }), E || u.val2lin !== w.val2Lin || (delete u.val2lin, delete u.lin2val), E && (u.userOptions.ordinal = !1, u.lin2val = w.lin2Val, u.val2lin = w.val2Lin, u.setExtremes = function(r, o, i, s, l) {
              if (d.hasBreaks) {
                let t, e = this.options.breaks || [];
                for (; t = d.findBreakAt(r, e); ) r = t.to;
                for (; t = d.findBreakAt(o, e); ) o = t.from;
                o < r && (o = r);
              }
              u.constructor.prototype.setExtremes.call(this, r, o, i, s, l);
            }, u.setAxisTranslation = function() {
              if (u.constructor.prototype.setAxisTranslation.call(this), d.unitLength = void 0, d.hasBreaks) {
                let r = u.options.breaks || [], o = [], i = [], s = z(u.pointRangePadding, 0), l = 0, t, e, a = u.userMin || u.min, n = u.userMax || u.max, h, p;
                r.forEach(function(f) {
                  e = f.repeat || 1 / 0, I(a) && I(n) && (w.isInBreak(f, a) && (a += f.to % e - a % e), w.isInBreak(f, n) && (n -= n % e - f.from % e));
                }), r.forEach(function(f) {
                  if (h = f.from, e = f.repeat || 1 / 0, I(a) && I(n)) {
                    for (; h - e > a; ) h -= e;
                    for (; h < a; ) h += e;
                    for (p = h; p < n; p += e) o.push({ value: p, move: "in" }), o.push({ value: p + f.to - f.from, move: "out", size: f.breakSize });
                  }
                }), o.sort(function(f, m) {
                  return f.value === m.value ? (f.move === "in" ? 0 : 1) - (m.move === "in" ? 0 : 1) : f.value - m.value;
                }), t = 0, h = a, o.forEach(function(f) {
                  (t += f.move === "in" ? 1 : -1) === 1 && f.move === "in" && (h = f.value), t === 0 && I(h) && (i.push({ from: h, to: f.value, len: f.value - h - (f.size || 0) }), l += f.value - h - (f.size || 0));
                }), d.breakArray = i, I(a) && I(n) && I(u.min) && (d.unitLength = n - a - l + s, q(u, "afterBreaks"), u.staticScale ? u.transA = u.staticScale : d.unitLength && (u.transA *= (n - u.min + s) / d.unitLength), s && (u.minPixelPadding = u.transA * (u.minPointOffset || 0)), u.min = a, u.max = n);
              }
            }), z(B, !0) && u.chart.redraw();
          }
        }
        _.Additions = w;
      }(Y || (Y = {})), Y;
    }), J(x, "masters/modules/broken-axis.src.js", [x["Core/Globals.js"], x["Core/Axis/BrokenAxis.js"]], function(D, H) {
      return D.BrokenAxis = D.BrokenAxis || H, D.BrokenAxis.compose(D.Axis, D.Series), D;
    }), J(x, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
      return {};
    }), J(x, "Extensions/DataGrouping/ApproximationDefaults.js", [x["Extensions/DataGrouping/ApproximationRegistry.js"], x["Core/Utilities.js"]], function(D, H) {
      let { arrayMax: Y, arrayMin: V, correctFloat: Z, extend: q, isNumber: N } = H;
      function I(C) {
        let M = C.length, S = z(C);
        return N(S) && M && (S = Z(S / M)), S;
      }
      function z(C) {
        let M = C.length, S;
        if (!M && C.hasNulls) S = null;
        else if (M) for (S = 0; M--; ) S += C[M];
        return S;
      }
      let _ = { average: I, averages: function() {
        let C = [];
        return [].forEach.call(arguments, function(M) {
          C.push(I(M));
        }), C[0] === void 0 ? void 0 : C;
      }, close: function(C) {
        return C.length ? C[C.length - 1] : C.hasNulls ? null : void 0;
      }, high: function(C) {
        return C.length ? Y(C) : C.hasNulls ? null : void 0;
      }, hlc: function(C, M, S) {
        if (C = D.high(C), M = D.low(M), S = D.close(S), N(C) || N(M) || N(S)) return [C, M, S];
      }, low: function(C) {
        return C.length ? V(C) : C.hasNulls ? null : void 0;
      }, ohlc: function(C, M, S, U) {
        if (C = D.open(C), M = D.high(M), S = D.low(S), U = D.close(U), N(C) || N(M) || N(S) || N(U)) return [C, M, S, U];
      }, open: function(C) {
        return C.length ? C[0] : C.hasNulls ? null : void 0;
      }, range: function(C, M) {
        return C = D.low(C), M = D.high(M), N(C) || N(M) ? [C, M] : C === null && M === null ? null : void 0;
      }, sum: z };
      return q(D, _), _;
    }), J(x, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
      return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
    }), J(x, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [x["Extensions/DataGrouping/DataGroupingDefaults.js"], x["Core/Utilities.js"]], function(D, H) {
      let Y, { addEvent: V, extend: Z, merge: q, pick: N } = H;
      function I(M) {
        let S = this, U = S.series;
        U.forEach(function(b) {
          b.groupPixelWidth = void 0;
        }), U.forEach(function(b) {
          b.groupPixelWidth = S.getGroupPixelWidth && S.getGroupPixelWidth(), b.groupPixelWidth && (b.hasProcessed = !0), b.applyGrouping(!!M.hasExtremesChanged);
        });
      }
      function z() {
        let M = this.series, S = M.length, U = 0, b = !1, k, O;
        for (; S--; ) (O = M[S].options.dataGrouping) && (U = Math.max(U, N(O.groupPixelWidth, D.common.groupPixelWidth)), k = (M[S].processedXData || M[S].data).length, (M[S].groupPixelWidth || k > this.chart.plotSizeX / U || k && O.forced) && (b = !0));
        return b ? U : 0;
      }
      function _() {
        this.series.forEach(function(M) {
          M.hasProcessed = !1;
        });
      }
      function C(M, S) {
        let U;
        if (S = N(S, !0), M || (M = { forced: !1, units: null }), this instanceof Y) for (U = this.series.length; U--; ) this.series[U].update({ dataGrouping: M }, !1);
        else this.chart.options.series.forEach(function(b) {
          b.dataGrouping = typeof M == "boolean" ? M : q(M, b.dataGrouping);
        });
        this.ordinal && (this.ordinal.slope = void 0), S && this.chart.redraw();
      }
      return { compose: function(M) {
        Y = M;
        let S = M.prototype;
        S.applyGrouping || (V(M, "afterSetScale", _), V(M, "postProcessData", I), Z(S, { applyGrouping: I, getGroupPixelWidth: z, setDataGrouping: C }));
      } };
    }), J(x, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [x["Extensions/DataGrouping/ApproximationRegistry.js"], x["Extensions/DataGrouping/DataGroupingDefaults.js"], x["Core/Axis/DateTimeAxis.js"], x["Core/Defaults.js"], x["Core/Series/SeriesRegistry.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z, q) {
      let { series: { prototype: N } } = Z, { addEvent: I, defined: z, error: _, extend: C, isNumber: M, merge: S, pick: U } = q, b = N.generatePoints;
      function k(B) {
        var d;
        let u, E, r = this.chart, o = this.options.dataGrouping, i = this.allowDG !== !1 && o && U(o.enabled, r.options.isStock), s = this.reserveSpace(), l = this.currentDataGrouping, t, e, a = !1;
        i && !this.requireSorting && (this.requireSorting = a = !0);
        let n = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !B) || !i;
        if (a && (this.requireSorting = !1), n) return;
        this.destroyGroupedData();
        let h = o.groupAll ? this.xData : this.processedXData, p = o.groupAll ? this.yData : this.processedYData, f = r.plotSizeX, m = this.xAxis, v = m.options.ordinal, A = this.groupPixelWidth;
        if (A && h && h.length && f) {
          E = !0, this.isDirty = !0, this.points = null;
          let G = m.getExtremes(), R = G.min, P = G.max, j = v && m.ordinal && m.ordinal.getGroupIntervalFactor(R, P, this) || 1, T = A * (P - R) / f * j, W = m.getTimeTicks(Y.Additions.prototype.normalizeTimeTickInterval(T, o.units || H.units), Math.min(R, h[0]), Math.max(P, h[h.length - 1]), m.options.startOfWeek, h, this.closestPointRange), L = N.groupData.apply(this, [h, p, W, o.approximation]), F = L.groupedXData, K = L.groupedYData, X = 0;
          for (o && o.smoothed && F.length && (o.firstAnchor = "firstPoint", o.anchor = "middle", o.lastAnchor = "lastPoint", _(32, !1, r, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), u = 1; u < W.length; u++) W.info.segmentStarts && W.info.segmentStarts.indexOf(u) !== -1 || (X = Math.max(W[u] - W[u - 1], X));
          (t = W.info).gapSize = X, this.closestPointRange = W.info.totalRange, this.groupMap = L.groupMap, this.currentDataGrouping = t, function($, Q, tt) {
            let et = $.options.dataGrouping, ot = $.currentDataGrouping && $.currentDataGrouping.gapSize;
            if (!(et && $.xData && ot && $.groupMap)) return;
            let it = Q.length - 1, rt = et.anchor, lt = et.firstAnchor, pt = et.lastAnchor, ht = Q.length - 1, at = 0;
            if (lt && $.xData[0] >= Q[0]) {
              let nt;
              at++;
              let ut = $.groupMap[0].start, mt = $.groupMap[0].length;
              M(ut) && M(mt) && (nt = ut + (mt - 1)), Q[0] = { start: Q[0], middle: Q[0] + 0.5 * ot, end: Q[0] + ot, firstPoint: $.xData[0], lastPoint: nt && $.xData[nt] }[lt];
            }
            if (it > 0 && pt && ot && Q[it] >= tt - ot) {
              ht--;
              let nt = $.groupMap[$.groupMap.length - 1].start;
              Q[it] = { start: Q[it], middle: Q[it] + 0.5 * ot, end: Q[it] + ot, firstPoint: nt && $.xData[nt], lastPoint: $.xData[$.xData.length - 1] }[pt];
            }
            if (rt && rt !== "start") {
              let nt = ot * { middle: 0.5, end: 1 }[rt];
              for (; ht >= at; ) Q[ht] += nt, ht--;
            }
          }(this, F, P), s && (z((d = F)[0]) && M(m.min) && M(m.dataMin) && d[0] < m.min && ((!z(m.options.min) && m.min <= m.dataMin || m.min === m.dataMin) && (m.min = Math.min(d[0], m.min)), m.dataMin = Math.min(d[0], m.dataMin)), z(d[d.length - 1]) && M(m.max) && M(m.dataMax) && d[d.length - 1] > m.max && ((!z(m.options.max) && M(m.dataMax) && m.max >= m.dataMax || m.max === m.dataMax) && (m.max = Math.max(d[d.length - 1], m.max)), m.dataMax = Math.max(d[d.length - 1], m.dataMax))), o.groupAll && (this.allGroupedData = K, F = (e = this.cropData(F, K, m.min, m.max)).xData, K = e.yData, this.cropStart = e.start), this.processedXData = F, this.processedYData = K;
        } else this.groupMap = null, this.currentDataGrouping = void 0;
        this.hasGroupedData = E, this.preventGraphAnimation = (l && l.totalRange) !== (t && t.totalRange);
      }
      function O() {
        this.groupedData && (this.groupedData.forEach(function(B, d) {
          B && (this.groupedData[d] = B.destroy ? B.destroy() : null);
        }, this), this.groupedData.length = 0, delete this.allGroupedData);
      }
      function c() {
        b.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function w() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
      }
      function g(B, d, u, E) {
        let r = this, o = r.data, i = r.options && r.options.data, s = [], l = [], t = [], e = B.length, a = !!d, n = [], h = r.pointArrayMap, p = h && h.length, f = ["x"].concat(h || ["y"]), m = this.options.dataGrouping && this.options.dataGrouping.groupAll, v, A, G, R = 0, P = 0, j = typeof E == "function" ? E : E && D[E] ? D[E] : D[r.getDGApproximation && r.getDGApproximation() || "average"];
        if (p) {
          let W = h.length;
          for (; W--; ) n.push([]);
        } else n.push([]);
        let T = p || 1;
        for (let W = 0; W <= e; W++) if (!(B[W] < u[0])) {
          for (; u[R + 1] !== void 0 && B[W] >= u[R + 1] || W === e; ) {
            v = u[R], r.dataGroupInfo = { start: m ? P : r.cropStart + P, length: n[0].length, groupStart: v }, G = j.apply(r, n), r.pointClass && !z(r.dataGroupInfo.options) && (r.dataGroupInfo.options = S(r.pointClass.prototype.optionsToObject.call({ series: r }, r.options.data[r.cropStart + P])), f.forEach(function(L) {
              delete r.dataGroupInfo.options[L];
            })), G !== void 0 && (s.push(v), l.push(G), t.push(r.dataGroupInfo)), P = W;
            for (let L = 0; L < T; L++) n[L].length = 0, n[L].hasNulls = !1;
            if (R += 1, W === e) break;
          }
          if (W === e) break;
          if (h) {
            let L, F = r.options.dataGrouping && r.options.dataGrouping.groupAll ? W : r.cropStart + W, K = o && o[F] || r.pointClass.prototype.applyOptions.apply({ series: r }, [i[F]]);
            for (let X = 0; X < p; X++) M(L = K[h[X]]) ? n[X].push(L) : L === null && (n[X].hasNulls = !0);
          } else M(A = a ? d[W] : null) ? n[0].push(A) : A === null && (n[0].hasNulls = !0);
        }
        return { groupedXData: s, groupedYData: l, groupMap: t };
      }
      function y(B) {
        let d = B.options, u = this.type, E = this.chart.options.plotOptions, r = this.useCommonDataGrouping && H.common, o = H.seriesSpecific, i = V.defaultOptions.plotOptions[u].dataGrouping;
        if (E && (o[u] || r)) {
          let s = this.chart.rangeSelector;
          i || (i = S(H.common, o[u])), d.dataGrouping = S(r, i, E.series && E.series.dataGrouping, E[u].dataGrouping, this.userOptions.dataGrouping, !d.isInternal && s && M(s.selected) && s.buttonOptions[s.selected].dataGrouping);
        }
      }
      return { compose: function(B) {
        let d = B.prototype;
        d.applyGrouping || (I(B.prototype.pointClass, "update", function() {
          if (this.dataGroup) return _(24, !1, this.series.chart), !1;
        }), I(B, "afterSetOptions", y), I(B, "destroy", O), C(d, { applyGrouping: k, destroyGroupedData: O, generatePoints: c, getDGApproximation: w, groupData: g }));
      }, groupData: g };
    }), J(x, "Extensions/DataGrouping/DataGrouping.js", [x["Extensions/DataGrouping/DataGroupingAxisComposition.js"], x["Extensions/DataGrouping/DataGroupingDefaults.js"], x["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], x["Core/Templating.js"], x["Core/Globals.js"], x["Core/Utilities.js"]], function(D, H, Y, V, Z, q) {
      let { format: N } = V, { composed: I } = Z, { addEvent: z, extend: _, isNumber: C, pick: M, pushUnique: S } = q;
      function U(b) {
        var e;
        let k = this.chart, O = k.time, c = b.labelConfig, w = c.series, g = c.point, y = w.options, B = w.tooltipOptions, d = y.dataGrouping, u = w.xAxis, E = B.xDateFormat, r, o, i, s, l, t = B[b.isFooter ? "footerFormat" : "headerFormat"];
        if (u && u.options.type === "datetime" && d && C(c.key)) {
          o = w.currentDataGrouping, i = d.dateTimeLabelFormats || H.common.dateTimeLabelFormats, o ? (s = i[o.unitName], o.count === 1 ? E = s[0] : (E = s[1], r = s[2])) : !E && i && u.dateTime && (E = u.dateTime.getXDateFormat(c.x, B.dateTimeLabelFormats));
          let a = M((e = w.groupMap) == null ? void 0 : e[g.index].groupStart, c.key), n = a + (o == null ? void 0 : o.totalRange) - 1;
          l = O.dateFormat(E, a), r && (l += O.dateFormat(r, n)), w.chart.styledMode && (t = this.styledModeFormat(t)), b.text = N(t, { point: _(c.point, { key: l }), series: w }, k), b.preventDefault();
        }
      }
      return { compose: function(b, k, O) {
        D.compose(b), Y.compose(k), O && S(I, "DataGrouping") && z(O, "headerFormatter", U);
      }, groupData: Y.groupData };
    }), J(x, "masters/modules/datagrouping.src.js", [x["Core/Globals.js"], x["Extensions/DataGrouping/ApproximationDefaults.js"], x["Extensions/DataGrouping/ApproximationRegistry.js"], x["Extensions/DataGrouping/DataGrouping.js"]], function(D, H, Y, V) {
      return D.dataGrouping = D.dataGrouping || {}, D.dataGrouping.approximationDefaults = D.dataGrouping.approximationDefaults || H, D.dataGrouping.approximations = D.dataGrouping.approximations || Y, V.compose(D.Axis, D.Series, D.Tooltip), D;
    }), J(x, "Extensions/Annotations/NavigationBindingsUtilities.js", [x["Core/Utilities.js"]], function(D) {
      let { defined: H, isNumber: Y, pick: V } = D, Z = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: Z, getAssignedAxis: function(q) {
        return q.filter((N) => {
          let I = N.axis.getExtremes(), z = I.min, _ = I.max, C = V(N.axis.minPointOffset, 0);
          return Y(z) && Y(_) && N.value >= z - C && N.value <= _ + C && !N.axis.options.isInternal;
        })[0];
      }, getFieldType: function(q, N) {
        let I = Z[q], z = typeof N;
        return H(I) && (z = I), { string: "text", number: "number", boolean: "checkbox" }[z];
      } };
    }), J(x, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [x["Core/Utilities.js"], x["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(D, H) {
      let Y, { addEvent: V, isObject: Z, pick: q, defined: N, merge: I } = D, { getAssignedAxis: z } = H, _ = [], C = { enabled: !0, sensitivity: 1.1 }, M = (b) => (Z(b) || (b = { enabled: b != null ? b : !0 }), I(C, b)), S = function(b, k, O, c, w, g, y) {
        let B = q(y.type, b.zooming.type, ""), d = [];
        B === "x" ? d = O : B === "y" ? d = c : B === "xy" && (d = b.axes);
        let u = b.transform({ axes: d, to: { x: w - 5, y: g - 5, width: 10, height: 10 }, from: { x: w - 5 * k, y: g - 5 * k, width: 10 * k, height: 10 * k }, trigger: "mousewheel" });
        return u && (N(Y) && clearTimeout(Y), Y = setTimeout(() => {
          var E;
          (E = b.pointer) == null || E.drop();
        }, 400)), u;
      };
      function U() {
        let b = M(this.zooming.mouseWheel);
        b.enabled && V(this.container, "wheel", (k) => {
          var w, g;
          k = ((w = this.pointer) == null ? void 0 : w.normalize(k)) || k;
          let { pointer: O } = this, c = O && !O.inClass(k.target, "highcharts-no-mousewheel");
          if (this.isInsidePlot(k.chartX - this.plotLeft, k.chartY - this.plotTop) && c) {
            let y = b.sensitivity || 1.1, B = k.detail || (k.deltaY || 0) / 120, d = z(O.getCoordinates(k).xAxis), u = z(O.getCoordinates(k).yAxis);
            S(this, Math.pow(y, B), d ? [d.axis] : this.xAxis, u ? [u.axis] : this.yAxis, k.chartX, k.chartY, b) && ((g = k.preventDefault) == null || g.call(k));
          }
        });
      }
      return { compose: function(b) {
        _.indexOf(b) === -1 && (_.push(b), V(b, "afterGetContainer", U));
      } };
    }), J(x, "masters/modules/mouse-wheel-zoom.src.js", [x["Core/Globals.js"], x["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(D, H) {
      return D.MouseWheelZoom = D.MouseWheelZoom || H, D.MouseWheelZoom.compose(D.Chart), D;
    }), J(x, "masters/modules/stock.src.js", [x["Core/Globals.js"], x["Series/DataModifyComposition.js"], x["Stock/Navigator/Navigator.js"], x["Core/Axis/OrdinalAxis.js"], x["Stock/RangeSelector/RangeSelector.js"], x["Stock/Scrollbar/Scrollbar.js"], x["Core/Chart/StockChart.js"], x["Series/OHLC/OHLCSeries.js"], x["Series/Flags/FlagsSeries.js"]], function(D, H, Y, V, Z, q, N, I, z) {
      return D.Navigator = D.Navigator || Y, D.OrdinalAxis = D.OrdinalAxis || V, D.RangeSelector = D.RangeSelector || Z, D.Scrollbar = D.Scrollbar || q, D.stockChart = D.stockChart || N.stockChart, D.StockChart = D.StockChart || D.stockChart, D.extend(D.StockChart, N), H.compose(D.Series, D.Axis, D.Point), z.compose(D.Renderer), I.compose(D.Series), D.Navigator.compose(D.Chart, D.Axis, D.Series), D.OrdinalAxis.compose(D.Axis, D.Series, D.Chart), D.RangeSelector.compose(D.Axis, D.Chart), D.Scrollbar.compose(D.Axis), D.StockChart.compose(D.Chart, D.Axis, D.Series, D.SVGRenderer), D;
    });
  });
})(vt);
var Dt = vt.exports;
const bt = /* @__PURE__ */ kt(Dt), wt = At`.highcharts-navigator-handle,.highcharts-navigator-mask-inside,.highcharts-navigator-series{fill:var(--beacon-system-color-background-primary)}.highcharts-navigator-handle:hover{fill:var(--beacon-system-color-background-primary-hover)}.highcharts-navigator-mask-inside{fill:var(--beacon-system-color-background-secondary-hover);fill-opacity:1;stroke:var(--beacon-system-color-background-primary);stroke-width:var(--beacon-system-width-border-normal)}.highcharts-navigator-mask-outside{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-navigator-series{stroke:var(--beacon-system-color-data-viz-standard-1)}.highcharts-scrollbar-thumb{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb);fill:var(--thumb-color);stroke:var(--thumb-color)}.highcharts-scrollbar-thumb:hover{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb-hover)}.highcharts-scrollbar-track{--track-color: var(--beacon-component-scrollbar-color-background-track);fill:var(--track-color);stroke:var(--track-color)}.highcharts-range-input,.highcharts-navigator-outline{stroke:none}.highcharts-navigator-series .highcharts-area{fill-opacity:.08}`;
var Ot = Object.defineProperty, Et = Object.getOwnPropertyDescriptor, gt = (dt, st, x, J) => {
  for (var D = J > 1 ? void 0 : J ? Et(st, x) : st, H = dt.length - 1, Y; H >= 0; H--)
    (Y = dt[H]) && (D = (J ? Y(st, x, D) : Y(D)) || D);
  return J && D && Ot(st, x, D), D;
};
function jt(dt) {
  let st = class extends dt {
    constructor() {
      super(...arguments), this.navigator = !1, this.stockChart = !1, this.hideNavigator = !1;
    }
    static get navigatorStyles() {
      return wt;
    }
    /**
     * SVG path of the left handle at non-small breakpoints
     */
    static leftHandlePath(x, J, D, H) {
      return [
        "M",
        0,
        0,
        "H",
        16,
        "V",
        H,
        "H",
        0,
        "V",
        J,
        "Z",
        "M",
        9,
        H / 2 + 4,
        "l",
        -4,
        -4,
        4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    /**
     * SVG path of the right handle at non-small breakpoints
     */
    static rightHandlePath(x, J, D, H) {
      return [
        "M",
        -16,
        0,
        "H",
        0,
        "V",
        H,
        "H",
        -16,
        "V",
        J,
        "Z",
        "M",
        -9,
        H / 2 + 4,
        "l",
        4,
        -4,
        -4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    get localComponentOptions() {
      return xt.createChartOptions(super.localComponentOptions, {
        navigator: {
          enabled: (this.navigator || this.stockChart) && !this.hideNavigator,
          handles: st.handleOptionsDefault
        },
        responsive: {
          rules: [
            {
              condition: {
                minWidth: parseInt(yt, 10)
              },
              chartOptions: {
                navigator: {
                  height: 44,
                  handles: {
                    height: 44
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(Mt, 10)
              },
              chartOptions: {
                navigator: {
                  height: 56,
                  handles: {
                    height: 56
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(St, 10)
              },
              chartOptions: {
                navigator: {
                  height: 64,
                  handles: {
                    height: 64
                  }
                }
              }
            }
          ]
        },
        plotOptions: {
          series: {
            marker: {
              enabled: this.navigator ? !1 : !this.disableMarkers
            }
          }
        }
      });
    }
    initializeHighcharts(x) {
      super.initializeHighcharts(x), bt(ct), x.SVGRenderer.prototype.symbols.righthandle = st.rightHandlePath, x.SVGRenderer.prototype.symbols.lefthandle = st.leftHandlePath;
    }
    createChart() {
      const x = xt.createChartOptions(
        this.chartOptions,
        this.localComponentOptions,
        this.filteredOptions
      );
      return this.navigator || this.stockChart ? (bt(ct), ct.stockChart(this.chartContainer, x)) : ct.chart(this.chartContainer, x);
    }
    willUpdate(x) {
      var J;
      super.willUpdate(x), x.has("disableMarkers") && !this.navigator && ((J = this.chart) == null || J.update({
        plotOptions: {
          series: { marker: { enabled: !this.disableMarkers } }
        }
      }));
    }
  };
  return st.handleHeight = 40, st.handleOptionsDefault = {
    height: st.handleHeight,
    lineWidth: 0,
    symbols: ["lefthandle", "righthandle"],
    width: 16
  }, gt([
    ft({ type: Boolean })
  ], st.prototype, "navigator", 2), gt([
    ft({ type: Boolean, attribute: "stock-chart" })
  ], st.prototype, "stockChart", 2), gt([
    ft({ type: Boolean, attribute: "hide-navigator" })
  ], st.prototype, "hideNavigator", 2), st = gt([
    Ct("Navigator")
  ], st), st;
}
export {
  jt as N
};
